var _style, _defs, _rect, _rect2, _rect3, _polygon, _rect4, _polygon2, _rect5, _polygon3, _rect6, _polygon4, _rect7, _polygon5, _rect8, _polygon6, _rect9, _rect10, _rect11, _rect12, _rect13, _polygon7, _rect14, _rect15, _rect16, _rect17, _rect18, _polygon8, _rect19, _polygon9, _polygon10, _polygon11, _polygon12, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _polygon13, _rect26, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _rect27, _polygon21, _polygon22, _rect28, _polygon23, _rect29, _polygon24, _rect30, _rect31, _rect32, _rect33, _polygon25, _rect34, _polygon26, _polygon27, _rect35, _rect36, _rect37, _rect38, _polygon28, _rect39, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _rect47, _rect48, _rect49, _polygon39, _rect50, _rect51, _rect52, _rect53, _rect54, _polygon40, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _polygon41, _rect64, _polygon42, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _path, _path2, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _rect87, _rect88, _rect89, _rect90, _path16, _g3, _rect91, _path17, _g4, _path18, _path19, _path20, _path21, _rect92, _path22, _polygon43, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _rect93, _path29, _rect94, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _rect95, _path30, _polygon44, _path31, _rect96, _path32, _polygon45, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon46, _polygon47, _path41, _path42, _path43, _path44, _path45, _polygon48, _polygon49, _path46, _path47, _path48, _polygon50, _polygon51, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _rect97, _path57, _rect98, _path58, _g83, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g84, _g85, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g86, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect99, _rect100, _rect101, _rect102, _path85, _path86, _path87, _path88, _polygon52, _polygon53, _rect103, _polygon54, _polygon55, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _path89, _path90, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _rect117, _rect118, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_5_);}\n\t.st4{fill:url(#SVGID_6_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_7_);}\n\t.st6{fill:url(#SVGID_8_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st8{fill:url(#SVGID_10_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st10{fill:url(#SVGID_12_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_13_);}\n\t.st12{fill:url(#SVGID_14_);}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_15_);}\n\t.st14{fill:url(#SVGID_16_);}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_17_);}\n\t.st16{fill:url(#SVGID_18_);}\n\t.st17{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_19_);}\n\t.st18{fill:url(#SVGID_20_);}\n\t.st19{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_21_);}\n\t.st20{fill:url(#SVGID_22_);}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_23_);}\n\t.st22{fill:url(#SVGID_24_);}\n\t.st23{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_25_);}\n\t.st24{fill:url(#SVGID_26_);}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_27_);}\n\t.st26{fill:url(#SVGID_28_);}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_29_);}\n\t.st28{fill:url(#SVGID_30_);}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_31_);}\n\t.st30{fill:url(#SVGID_32_);}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_33_);}\n\t.st32{fill:url(#SVGID_34_);}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_35_);}\n\t.st34{fill:url(#SVGID_36_);}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_37_);}\n\t.st36{fill:url(#SVGID_38_);}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_39_);}\n\t.st38{fill:url(#SVGID_40_);}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_41_);}\n\t.st40{fill:url(#SVGID_42_);}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_43_);}\n\t.st42{fill:url(#SVGID_44_);}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_45_);}\n\t.st44{fill:url(#SVGID_46_);}\n\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_47_);}\n\t.st46{fill:url(#SVGID_48_);}\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_49_);}\n\t.st48{fill:url(#SVGID_50_);}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_51_);}\n\t.st50{fill:url(#SVGID_52_);}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_53_);}\n\t.st52{fill:url(#SVGID_54_);}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_55_);}\n\t.st54{fill:url(#SVGID_56_);}\n\t.st55{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_57_);}\n\t.st56{fill:url(#SVGID_58_);}\n\t.st57{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_59_);}\n\t.st58{fill:url(#SVGID_60_);}\n\t.st59{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_61_);}\n\t.st60{fill:url(#SVGID_62_);}\n\t.st61{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_63_);}\n\t.st62{fill:url(#SVGID_64_);}\n\t.st63{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_65_);}\n\t.st64{fill:url(#SVGID_66_);}\n\t.st65{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_67_);}\n\t.st66{fill:url(#SVGID_68_);}\n\t.st67{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_69_);}\n\t.st68{fill:url(#SVGID_70_);}\n\t.st69{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_71_);}\n\t.st70{fill:url(#SVGID_72_);}\n\t.st71{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_73_);}\n\t.st72{fill:url(#SVGID_74_);}\n\t.st73{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_75_);}\n\t.st74{fill:url(#SVGID_76_);}\n\t.st75{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_77_);}\n\t.st76{fill:url(#SVGID_78_);}\n\t.st77{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_79_);}\n\t.st78{fill:url(#SVGID_80_);}\n\t.st79{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_81_);}\n\t.st80{fill:url(#SVGID_82_);}\n\t.st81{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_83_);}\n\t.st82{fill:url(#SVGID_84_);}\n\t.st83{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_85_);}\n\t.st84{fill:url(#SVGID_86_);}\n\t.st85{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_87_);}\n\t.st86{fill:url(#SVGID_88_);}\n\t.st87{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_89_);}\n\t.st88{fill:url(#SVGID_90_);}\n\t.st89{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_91_);}\n\t.st90{fill:url(#SVGID_92_);}\n\t.st91{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_93_);}\n\t.st92{fill:url(#SVGID_94_);}\n\t.st93{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_95_);}\n\t.st94{fill:url(#SVGID_96_);}\n\t.st95{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_97_);}\n\t.st96{fill:url(#SVGID_98_);}\n\t.st97{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_99_);}\n\t.st98{fill:url(#SVGID_100_);}\n\t.st99{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_101_);}\n\t.st100{fill:url(#SVGID_102_);}\n\t.st101{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_103_);}\n\t.st102{fill:url(#SVGID_104_);}\n\t.st103{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_105_);}\n\t.st104{fill:url(#SVGID_106_);}\n\t.st105{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_107_);}\n\t.st106{fill:url(#SVGID_108_);}\n\t.st107{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_109_);}\n\t.st108{fill:url(#SVGID_110_);}\n\t.st109{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_111_);}\n\t.st110{fill:url(#SVGID_112_);}\n\t.st111{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_113_);}\n\t.st112{fill:url(#SVGID_114_);}\n\t.st113{fill:url(#SVGID_115_);}\n\t.st114{fill:url(#SVGID_116_);}\n\t.st115{fill:url(#SVGID_117_);}\n\t.st116{fill:url(#SVGID_118_);}\n\t.st117{fill:url(#SVGID_119_);}\n\t.st118{fill:url(#SVGID_120_);}\n\t.st119{fill:url(#SVGID_121_);}\n\t.st120{fill:url(#SVGID_122_);}\n\t.st121{fill:url(#SVGID_123_);}\n\t.st122{fill:url(#SVGID_124_);}\n\t.st123{fill:url(#SVGID_125_);}\n\t.st124{fill:url(#SVGID_126_);}\n\t.st125{fill:url(#SVGID_127_);}\n\t.st126{fill:url(#SVGID_128_);}\n\t.st127{fill:url(#SVGID_129_);}\n\t.st128{fill:url(#SVGID_130_);}\n\t.st129{fill:url(#SVGID_131_);}\n\t.st130{fill:url(#SVGID_132_);}\n\t.st131{fill:url(#SVGID_133_);}\n\t.st132{fill:url(#SVGID_134_);}\n\t.st133{fill:url(#SVGID_135_);}\n\t.st134{fill:#02247D;}\n\t.st135{fill:url(#SVGID_136_);}\n\t.st136{fill:#FFFFFF;}\n\t.st137{fill:url(#SVGID_137_);}\n\t.st138{fill:url(#SVGID_138_);}\n\t.st139{fill:url(#SVGID_139_);}\n\t.st140{fill:url(#SVGID_140_);}\n\t.st141{fill:url(#SVGID_141_);}\n\t.st142{fill:url(#SVGID_142_);}\n\t.st143{fill:#032895;}\n\t.st144{fill:url(#SVGID_143_);}\n\t.st145{fill:url(#SVGID_144_);}\n\t.st146{fill:url(#SVGID_145_);}\n\t.st147{fill:url(#SVGID_146_);}\n\t.st148{fill:url(#SVGID_147_);}\n\t.st149{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_148_);}\n\t.st150{fill:url(#SVGID_149_);}\n\t.st151{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_150_);}\n\t.st152{fill:url(#SVGID_151_);}\n\t.st153{fill:url(#SVGID_152_);}\n\t.st154{fill:url(#SVGID_153_);}\n\t.st155{fill:url(#SVGID_154_);}\n\t.st156{fill:url(#SVGID_155_);}\n\t.st157{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_156_);}\n\t.st158{fill:url(#SVGID_157_);}\n\t.st159{fill:#06FBFE;}\n\t.st160{fill:url(#SVGID_158_);}\n\t.st161{fill:url(#SVGID_159_);}\n\t.st162{fill:url(#SVGID_160_);}\n\t.st163{fill:url(#SVGID_161_);}\n\t.st164{fill:url(#SVGID_162_);}\n\t.st165{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_163_);}\n\t.st166{fill-rule:evenodd;clip-rule:evenodd;fill:#02247D;}\n\t.st167{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st168{fill:url(#SVGID_164_);}\n\t.st169{fill:url(#SVGID_165_);}\n\t.st170{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_166_);}\n\t.st171{fill:url(#SVGID_167_);}\n\t.st172{fill:url(#SVGID_168_);}\n\t.st173{fill:url(#SVGID_169_);}\n\t.st174{fill:url(#SVGID_170_);}\n\t.st175{fill:url(#SVGID_171_);}\n\t.st176{fill:url(#SVGID_172_);}\n\t.st177{fill:url(#SVGID_173_);}\n\t.st178{fill:url(#SVGID_174_);}\n\t.st179{fill:url(#SVGID_175_);}\n\t.st180{fill:url(#SVGID_176_);}\n\t.st181{fill:url(#SVGID_177_);}\n\t.st182{fill:url(#SVGID_178_);}\n\t.st183{fill:url(#SVGID_179_);}\n\t.st184{fill:url(#SVGID_180_);}\n\t.st185{fill:url(#SVGID_181_);}\n\t.st186{fill:url(#SVGID_182_);}\n\t.st187{fill:url(#SVGID_183_);}\n\t.st188{fill:url(#SVGID_184_);}\n\t.st189{fill:url(#SVGID_185_);}\n\t.st190{fill:url(#SVGID_186_);}\n\t.st191{fill:url(#SVGID_187_);}\n\t.st192{fill:url(#SVGID_188_);}\n\t.st193{fill:url(#SVGID_189_);}\n\t.st194{fill:url(#SVGID_190_);}\n\t.st195{fill:url(#SVGID_191_);}\n\t.st196{fill:url(#SVGID_192_);}\n\t.st197{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_193_);}\n\t.st198{fill:url(#SVGID_194_);}\n\t.st199{fill:url(#SVGID_195_);}\n\t.st200{fill:url(#SVGID_196_);}\n\t.st201{fill:url(#SVGID_197_);}\n\t.st202{fill:url(#SVGID_198_);}\n\t.st203{fill:url(#SVGID_199_);}\n\t.st204{fill:url(#SVGID_200_);}\n\t.st205{fill:#FFFEFF;}\n\t.st206{fill:url(#SVGID_201_);}\n\t.st207{fill:url(#SVGID_202_);}\n\t.st208{fill:url(#SVGID_203_);}\n\t.st209{fill:url(#SVGID_204_);}\n\t.st210{fill:url(#SVGID_205_);}\n\t.st211{fill:url(#SVGID_206_);}\n\t.st212{fill:url(#SVGID_207_);}\n\t.st213{fill:url(#SVGID_208_);}\n\t.st214{fill:url(#SVGID_209_);}\n\t.st215{fill:url(#SVGID_210_);}\n\t.st216{fill:url(#SVGID_211_);}\n\t.st217{fill:url(#SVGID_212_);}\n\t.st218{fill:url(#SVGID_213_);}\n\t.st219{fill:url(#SVGID_214_);}\n\t.st220{fill:url(#SVGID_215_);}\n\t.st221{fill:url(#SVGID_216_);}\n\t.st222{fill:url(#SVGID_217_);}\n\t.st223{fill:url(#SVGID_218_);}\n\t.st224{fill:url(#SVGID_219_);}\n\t.st225{fill:url(#SVGID_220_);}\n\t.st226{fill:url(#SVGID_221_);}\n\t.st227{fill:url(#SVGID_222_);}\n\t.st228{fill:url(#SVGID_223_);}\n\t.st229{fill:url(#SVGID_224_);}\n\t.st230{fill:url(#SVGID_225_);}\n\t.st231{fill:url(#SVGID_226_);}\n\t.st232{fill:url(#SVGID_227_);}\n\t.st233{fill:url(#SVGID_228_);}\n\t.st234{fill:url(#SVGID_229_);}\n\t.st235{fill:url(#SVGID_230_);}\n\t.st236{fill:url(#SVGID_231_);}\n\t.st237{fill:url(#SVGID_232_);}\n\t.st238{fill:url(#SVGID_233_);}\n\t.st239{fill:url(#SVGID_234_);}\n\t.st240{fill:url(#SVGID_235_);}\n\t.st241{fill:url(#SVGID_236_);}\n\t.st242{fill:url(#SVGID_237_);}\n\t.st243{fill:url(#SVGID_238_);}\n\t.st244{fill:url(#SVGID_239_);}\n\t.st245{fill:url(#SVGID_240_);}\n\t.st246{fill:url(#SVGID_241_);}\n\t.st247{fill:url(#SVGID_242_);}\n\t.st248{fill:url(#SVGID_243_);}\n\t.st249{fill:url(#SVGID_244_);}\n\t.st250{fill:url(#SVGID_245_);}\n\t.st251{fill:url(#SVGID_246_);}\n\t.st252{fill:url(#SVGID_247_);}\n\t.st253{fill:url(#SVGID_248_);}\n\t.st254{fill:url(#SVGID_249_);}\n\t.st255{fill:url(#SVGID_250_);}\n\t.st256{fill:url(#SVGID_251_);}\n\t.st257{fill:url(#SVGID_252_);}\n\t.st258{fill:url(#SVGID_253_);}\n\t.st259{fill:url(#SVGID_254_);}\n\t.st260{fill:url(#SVGID_255_);}\n\t.st261{fill:url(#SVGID_256_);}\n\t.st262{fill:url(#SVGID_257_);}\n\t.st263{fill:url(#SVGID_258_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 900,
    height: 600
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 300,
    x2: 900,
    y2: 300
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1908,
    style: {
      stopColor: "#6B51D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1790CC"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 794.878,
    y1: 7297.7729,
    x2: 819.334,
    y2: 7297.7729,
    gradientTransform: "matrix(-1 0 0 -1 1297.924 7608.0508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 478.68,
    y: 208.13,
    className: "st2",
    width: 24.27,
    height: 204.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6035,
    y1: 223.7241,
    x2: 483.8809,
    y2: 223.7241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 478.6,
    y: 222.94,
    className: "st3",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6026,
    y1: 223.7246,
    x2: 484.8828,
    y2: 223.7246
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "484.88,221.94 484.88,225.5 477.61,225.51 477.6,221.95  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_711_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6074,
    y1: 228.228,
    x2: 483.8858,
    y2: 228.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 478.61,
    y: 227.45,
    className: "st5",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6065,
    y1: 228.2285,
    x2: 484.8867,
    y2: 228.2285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "484.88,226.44 484.89,230 477.61,230.01 477.61,226.45  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_710_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6113,
    y1: 232.7299,
    x2: 487.1026,
    y2: 232.7299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 478.61,
    y: 231.95,
    className: "st7",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6104,
    y1: 232.7294,
    x2: 488.1035,
    y2: 232.7294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "488.1,230.94 488.1,234.51 477.61,234.51 477.61,230.95  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_709_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6152,
    y1: 237.3257,
    x2: 483.8936,
    y2: 237.3257
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 478.62,
    y: 236.54,
    className: "st9",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6143,
    y1: 237.3262,
    x2: 484.8955,
    y2: 237.3262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "484.89,235.54 484.9,239.1 477.62,239.11 477.61,235.55  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_708_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6201,
    y1: 241.8291,
    x2: 483.8985,
    y2: 241.8291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 478.62,
    y: 241.05,
    className: "st11",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6192,
    y1: 241.8301,
    x2: 484.8994,
    y2: 241.8301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "484.9,240.05 484.9,243.61 477.62,243.61 477.62,240.05  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_706_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.624,
    y1: 246.332,
    x2: 487.1143,
    y2: 246.332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 478.62,
    y: 245.55,
    className: "st13",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.625,
    y1: 246.332,
    x2: 488.1162,
    y2: 246.332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "488.11,244.55 488.12,248.11 477.62,248.12 477.62,244.56  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6289,
    y1: 250.9268,
    x2: 483.9063,
    y2: 250.9268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 478.63,
    y: 250.15,
    className: "st15",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6279,
    y1: 250.9277,
    x2: 484.9072,
    y2: 250.9277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 477.63,
    y: 249.15,
    className: "st16",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_701_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6319,
    y1: 255.4307,
    x2: 483.9102,
    y2: 255.4307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 478.63,
    y: 254.65,
    className: "st17",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6319,
    y1: 255.4317,
    x2: 484.9111,
    y2: 255.4317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 477.63,
    y: 253.65,
    className: "st18",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_700_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6367,
    y1: 259.9331,
    x2: 487.1279,
    y2: 259.9331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 478.64,
    y: 259.15,
    className: "st19",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6358,
    y1: 259.9326,
    x2: 488.1289,
    y2: 259.9326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "488.12,258.15 488.13,261.71 477.64,261.72 477.64,258.16  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_699_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6406,
    y1: 264.5288,
    x2: 483.919,
    y2: 264.5288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 478.64,
    y: 263.75,
    className: "st21",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6397,
    y1: 264.5283,
    x2: 484.9199,
    y2: 264.5283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 477.64,
    y: 262.75,
    className: "st22",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_698_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6445,
    y1: 269.0322,
    x2: 483.9229,
    y2: 269.0322
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 478.65,
    y: 268.25,
    className: "st23",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6436,
    y1: 269.0332,
    x2: 484.9238,
    y2: 269.0332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 477.65,
    y: 267.25,
    className: "st24",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_695_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6485,
    y1: 273.5341,
    x2: 487.1397,
    y2: 273.5341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 478.65,
    y: 272.75,
    className: "st25",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6475,
    y1: 273.5352,
    x2: 488.1406,
    y2: 273.5352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "488.14,271.75 488.14,275.31 477.65,275.32 477.65,271.76  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_693_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6485,
    y1: 273.5341,
    x2: 487.1397,
    y2: 273.5341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 478.65,
    y: 272.75,
    className: "st27",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6475,
    y1: 273.5352,
    x2: 488.1406,
    y2: 273.5352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "488.14,271.75 488.14,275.31 477.65,275.32 477.65,271.76  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6533,
    y1: 278.1299,
    x2: 483.9317,
    y2: 278.1299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "483.93,278.91 478.65,278.91 478.65,277.35 483.93,277.35  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6524,
    y1: 278.1299,
    x2: 484.9326,
    y2: 278.1299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "484.93,276.35 484.93,279.91 477.66,279.91 477.65,276.35  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6572,
    y1: 282.6338,
    x2: 483.9356,
    y2: 282.6338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "483.94,283.41 478.66,283.42 478.66,281.86 483.93,281.85  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6572,
    y1: 282.6338,
    x2: 484.9365,
    y2: 282.6338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 477.66,
    y: 280.85,
    className: "st32",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_689_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6611,
    y1: 287.1363,
    x2: 487.1514,
    y2: 287.1363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 478.66,
    y: 286.36,
    className: "st33",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6611,
    y1: 287.1357,
    x2: 488.1533,
    y2: 287.1357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 477.66,
    y: 285.36,
    className: "st34",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_688_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6611,
    y1: 287.1363,
    x2: 487.1514,
    y2: 287.1363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 478.66,
    y: 286.36,
    className: "st35",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6611,
    y1: 287.1357,
    x2: 488.1533,
    y2: 287.1357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 477.66,
    y: 285.36,
    className: "st36",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_687_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.666,
    y1: 291.731,
    x2: 483.9434,
    y2: 291.731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 478.67,
    y: 290.95,
    className: "st37",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6651,
    y1: 291.7304,
    x2: 484.9453,
    y2: 291.7304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "484.94,289.95 484.95,293.51 477.67,293.51 477.67,289.95  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6699,
    y1: 296.2349,
    x2: 483.9473,
    y2: 296.2349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 478.67,
    y: 295.45,
    className: "st39",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.669,
    y1: 296.2354,
    x2: 484.9492,
    y2: 296.2354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "484.95,294.45 484.95,298.01 477.67,298.02 477.67,294.46  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_685_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6738,
    y1: 300.7378,
    x2: 487.1651,
    y2: 300.7378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "487.17,301.51 478.67,301.52 478.67,299.96 487.16,299.95  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6729,
    y1: 300.7373,
    x2: 488.166,
    y2: 300.7373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "488.16,298.95 488.17,302.51 477.68,302.52 477.67,298.96  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_667_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6738,
    y1: 300.7378,
    x2: 487.1651,
    y2: 300.7378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "487.17,301.51 478.67,301.52 478.67,299.96 487.16,299.95  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6729,
    y1: 300.7373,
    x2: 488.166,
    y2: 300.7373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "488.16,298.95 488.17,302.51 477.68,302.52 477.67,298.96  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_664_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6777,
    y1: 305.333,
    x2: 483.9561,
    y2: 305.333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "483.96,306.11 478.68,306.12 478.68,304.55 483.96,304.55  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6768,
    y1: 305.3321,
    x2: 484.958,
    y2: 305.3321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "484.95,303.55 484.96,307.11 477.68,307.12 477.68,303.56  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_663_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6826,
    y1: 309.8359,
    x2: 483.961,
    y2: 309.8359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 478.68,
    y: 309.06,
    className: "st47",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6817,
    y1: 309.8359,
    x2: 484.9619,
    y2: 309.8359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "484.96,308.05 484.96,311.61 477.68,311.62 477.68,308.06  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_660_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6865,
    y1: 314.3383,
    x2: 487.1768,
    y2: 314.3383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "487.18,315.11 478.69,315.12 478.69,313.56 487.17,313.55  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6875,
    y1: 314.3388,
    x2: 488.1777,
    y2: 314.3388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 477.69,
    y: 312.56,
    className: "st50",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_658_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6865,
    y1: 314.3383,
    x2: 487.1768,
    y2: 314.3383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "487.18,315.11 478.69,315.12 478.69,313.56 487.17,313.55  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6875,
    y1: 314.3388,
    x2: 488.1777,
    y2: 314.3388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 477.69,
    y: 312.56,
    className: "st52",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_651_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6904,
    y1: 318.9346,
    x2: 483.9688,
    y2: 318.9346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "483.97,319.71 478.69,319.72 478.69,318.16 483.97,318.15  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6914,
    y1: 318.9336,
    x2: 484.9697,
    y2: 318.9336
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 477.69,
    y: 317.15,
    className: "st54",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_650_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6953,
    y1: 323.4375,
    x2: 483.9727,
    y2: 323.4375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 478.7,
    y: 322.66,
    className: "st55",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6944,
    y1: 323.4375,
    x2: 484.9736,
    y2: 323.4375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 477.7,
    y: 321.66,
    className: "st56",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_644_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6992,
    y1: 327.9399,
    x2: 487.1895,
    y2: 327.9399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 478.7,
    y: 327.16,
    className: "st57",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6983,
    y1: 327.9405,
    x2: 488.1914,
    y2: 327.9405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "488.19,326.16 488.19,329.72 477.7,329.73 477.7,326.17  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_643_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.6992,
    y1: 327.9399,
    x2: 487.1895,
    y2: 327.9399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 478.7,
    y: 327.16,
    className: "st59",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.6983,
    y1: 327.9405,
    x2: 488.1914,
    y2: 327.9405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "488.19,326.16 488.19,329.72 477.7,329.73 477.7,326.17  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_642_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7031,
    y1: 332.5361,
    x2: 483.9805,
    y2: 332.5361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "483.98,333.31 478.7,333.32 478.7,331.76 483.98,331.75  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7022,
    y1: 332.5352,
    x2: 484.9805,
    y2: 332.5352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 477.7,
    y: 330.75,
    className: "st62",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_641_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.707,
    y1: 337.0391,
    x2: 483.9854,
    y2: 337.0391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 478.71,
    y: 336.26,
    className: "st63",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7061,
    y1: 337.0391,
    x2: 484.9863,
    y2: 337.0391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 477.71,
    y: 335.26,
    className: "st64",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_640_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.711,
    y1: 341.5415,
    x2: 487.2022,
    y2: 341.5415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 478.71,
    y: 340.76,
    className: "st65",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.71,
    y1: 341.541,
    x2: 488.2031,
    y2: 341.541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "488.2,339.75 488.2,343.32 477.71,343.33 477.71,339.76  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.711,
    y1: 341.5415,
    x2: 487.2022,
    y2: 341.5415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 478.71,
    y: 340.76,
    className: "st67",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.71,
    y1: 341.541,
    x2: 488.2031,
    y2: 341.541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "488.2,339.75 488.2,343.32 477.71,343.33 477.71,339.76  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_638_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7158,
    y1: 346.1372,
    x2: 483.9942,
    y2: 346.1372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "483.99,346.92 478.72,346.92 478.72,345.36 483.99,345.35  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7149,
    y1: 346.1367,
    x2: 484.9951,
    y2: 346.1367
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "484.99,344.35 485,347.92 477.72,347.92 477.71,344.36  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_637_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7197,
    y1: 350.6416,
    x2: 483.9981,
    y2: 350.6416
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "484,351.42 478.72,351.42 478.72,349.86 484,349.86  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7207,
    y1: 350.6406,
    x2: 484.999,
    y2: 350.6406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "485,348.86 485,352.42 477.72,352.42 477.72,348.86  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_636_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7236,
    y1: 355.1426,
    x2: 487.2139,
    y2: 355.1426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 478.72,
    y: 354.36,
    className: "st73",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7236,
    y1: 355.1436,
    x2: 488.2158,
    y2: 355.1436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 477.73,
    y: 353.36,
    className: "st74",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_633_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7236,
    y1: 355.1426,
    x2: 487.2139,
    y2: 355.1426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 478.72,
    y: 354.36,
    className: "st75",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7236,
    y1: 355.1436,
    x2: 488.2158,
    y2: 355.1436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 477.73,
    y: 353.36,
    className: "st76",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_632_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7285,
    y1: 359.7388,
    x2: 484.0059,
    y2: 359.7388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 478.73,
    y: 358.96,
    className: "st77",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7276,
    y1: 359.7383,
    x2: 485.0069,
    y2: 359.7383
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 477.73,
    y: 357.96,
    className: "st78",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7324,
    y1: 364.2422,
    x2: 484.0098,
    y2: 364.2422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 478.73,
    y: 363.46,
    className: "st79",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7315,
    y1: 364.2422,
    x2: 485.0117,
    y2: 364.2422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "485.01,362.46 485.01,366.02 477.74,366.03 477.73,362.46  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_630_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7363,
    y1: 368.7447,
    x2: 487.2276,
    y2: 368.7447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "487.23,369.52 478.74,369.53 478.74,367.97 487.23,367.96  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7354,
    y1: 368.7441,
    x2: 488.2285,
    y2: 368.7441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "488.22,366.96 488.23,370.52 477.74,370.53 477.74,366.97  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_629_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7363,
    y1: 368.7447,
    x2: 487.2276,
    y2: 368.7447
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "487.23,369.52 478.74,369.53 478.74,367.97 487.23,367.96  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7354,
    y1: 368.7441,
    x2: 488.2285,
    y2: 368.7441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "488.22,366.96 488.23,370.52 477.74,370.53 477.74,366.97  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_624_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7402,
    y1: 373.3398,
    x2: 484.0176,
    y2: 373.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 478.74,
    y: 372.56,
    className: "st85",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7393,
    y1: 373.3398,
    x2: 485.0195,
    y2: 373.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 477.74,
    y: 371.56,
    className: "st86",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_620_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7442,
    y1: 377.8428,
    x2: 484.0225,
    y2: 377.8428
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 478.75,
    y: 377.06,
    className: "st87",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7442,
    y1: 377.8438,
    x2: 485.0244,
    y2: 377.8438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "485.02,376.06 485.02,379.62 477.75,379.63 477.74,376.07  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_619_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.749,
    y1: 382.3457,
    x2: 487.2393,
    y2: 382.3457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 478.75,
    y: 381.57,
    className: "st89",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7481,
    y1: 382.3466,
    x2: 488.2402,
    y2: 382.3466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 477.75,
    y: 380.57,
    className: "st90",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_607_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.749,
    y1: 382.3457,
    x2: 487.2393,
    y2: 382.3457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 478.75,
    y: 381.57,
    className: "st91",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7481,
    y1: 382.3466,
    x2: 488.2402,
    y2: 382.3466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 477.75,
    y: 380.57,
    className: "st92",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_602_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7529,
    y1: 386.9409,
    x2: 484.0313,
    y2: 386.9409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 478.75,
    y: 386.16,
    className: "st93",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7539,
    y1: 386.9414,
    x2: 485.0322,
    y2: 386.9414
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "485.03,385.16 485.03,388.72 477.75,388.73 477.75,385.16  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_601_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7569,
    y1: 391.4448,
    x2: 484.0352,
    y2: 391.4448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 478.76,
    y: 390.66,
    className: "st95",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7569,
    y1: 391.4453,
    x2: 485.0361,
    y2: 391.4453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 477.76,
    y: 389.67,
    className: "st96",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_600_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7617,
    y1: 395.9472,
    x2: 487.251,
    y2: 395.9472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 478.76,
    y: 395.17,
    className: "st97",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7608,
    y1: 395.9472,
    x2: 488.2529,
    y2: 395.9472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 477.76,
    y: 394.17,
    className: "st98",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_599_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7617,
    y1: 395.9472,
    x2: 487.251,
    y2: 395.9472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 478.76,
    y: 395.17,
    className: "st99",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7608,
    y1: 395.9472,
    x2: 488.2529,
    y2: 395.9472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 477.76,
    y: 394.17,
    className: "st100",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_597_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_103_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7656,
    y1: 400.542,
    x2: 484.043,
    y2: 400.542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 478.77,
    y: 399.76,
    className: "st101",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_104_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7647,
    y1: 400.5429,
    x2: 485.044,
    y2: 400.5429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 477.77,
    y: 398.76,
    className: "st102",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_589_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7695,
    y1: 405.0464,
    x2: 484.0469,
    y2: 405.0464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 478.77,
    y: 404.27,
    className: "st103",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7686,
    y1: 405.0459,
    x2: 485.0488,
    y2: 405.0459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "485.04,403.26 485.05,406.82 477.77,406.83 477.77,403.27  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_588_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.7735,
    y1: 409.5488,
    x2: 487.2647,
    y2: 409.5488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 478.77,
    y: 408.77,
    className: "st105",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7725,
    y1: 409.5489,
    x2: 488.2656,
    y2: 409.5489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "488.26,407.76 488.27,411.32 477.78,411.33 477.77,407.77  "
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_587_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.5908,
    y1: 210.1221,
    x2: 483.8692,
    y2: 210.1221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 478.59,
    y: 209.34,
    className: "st107",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.5918,
    y1: 210.123,
    x2: 484.8701,
    y2: 210.123
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 477.59,
    y: 208.34,
    className: "st108",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_586_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.5947,
    y1: 214.6265,
    x2: 483.8731,
    y2: 214.6265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 478.6,
    y: 213.85,
    className: "st109",
    width: 5.28,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.5947,
    y1: 214.626,
    x2: 484.874,
    y2: 214.626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 477.6,
    y: 212.85,
    className: "st110",
    width: 7.28,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_419_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_113_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.5996,
    y1: 219.1289,
    x2: 487.0889,
    y2: 219.1289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 478.6,
    y: 218.35,
    className: "st111",
    width: 8.49,
    height: 1.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_114_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.5986,
    y1: 219.1289,
    x2: 488.0908,
    y2: 219.1289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    style: {
      stopColor: "#1DDFFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6486,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 477.6,
    y: 217.35,
    className: "st112",
    width: 10.49,
    height: 3.56
  })))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_115_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.876,
    y1: 7297.7725,
    x2: 820.335,
    y2: 7297.7725,
    gradientTransform: "matrix(-1 0 0 -1 1297.924 7608.0508)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3468,
    style: {
      stopColor: "#8C57E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4825,
    style: {
      stopColor: "#7E67E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#6B7EEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7299,
    style: {
      stopColor: "#539CEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    style: {
      stopColor: "#35C1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9562,
    style: {
      stopColor: "#13ECFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M503.86,207.12l0.19,206.29l-26.27,0.03l-0.19-206.29L503.86,207.12z M502.05,411.41l-0.19-202.29 l-22.27,0.02l0.18,202.29L502.05,411.41z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_116_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.0117,
    y1: 480.8145,
    x2: 700.9463,
    y2: 480.8145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#022894"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M685.01,433.01H67.95c-8.8,0-15.94,7.14-15.94,15.94l0,0c0,8.8,7.13,15.94,15.94,15.94h93.31 c8.8,0,15.94,7.13,15.94,15.94l0,0c0,8.8-7.13,15.94-15.94,15.94H142c-8.8,0-15.94,7.13-15.94,15.94l0,0 c0,8.8,7.13,15.94,15.94,15.94h532.78c8.8,0,15.94-7.13,15.94-15.94l0,0c0-8.8-7.13-15.94-15.94-15.94h-2.5 c-8.8,0-15.94-7.13-15.94-15.94l0,0c0-8.8,7.13-15.94,15.94-15.94h12.73c8.8,0,15.94-7.13,15.94-15.94l0,0 C700.95,440.14,693.81,433.01,685.01,433.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_117_",
    gradientUnits: "userSpaceOnUse",
    x1: 495.6494,
    y1: 461.2949,
    x2: 583.8467,
    y2: 461.2949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 495.65,
    y: 460.29,
    className: "st115",
    width: 88.2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_118_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.7129,
    y1: 442.3896,
    x2: 417.0606,
    y2: 442.3896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 441.39,
    className: "st116",
    width: 195.35,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_119_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.9199,
    y1: 461.2949,
    x2: 479.6533,
    y2: 461.2949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 461.92,
    y: 460.29,
    className: "st117",
    width: 17.73,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: 596.8565,
    y1: 479.8145,
    x2: 648.624,
    y2: 479.8145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 596.86,
    y: 478.81,
    className: "st118",
    width: 51.77,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_121_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.0586,
    y1: 479.8145,
    x2: 587.4678,
    y2: 479.8145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 577.06,
    y: 478.81,
    className: "st119",
    width: 10.41,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_122_",
    gradientUnits: "userSpaceOnUse",
    x1: 592.9199,
    y1: 443.5654,
    x2: 623.0723,
    y2: 443.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 592.92,
    y: 442.57,
    className: "st120",
    width: 30.15,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_123_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.2608,
    y1: 443.5654,
    x2: 644.4922,
    y2: 443.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 634.26,
    y: 442.57,
    className: "st121",
    width: 10.23,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_124_",
    gradientUnits: "userSpaceOnUse",
    x1: 581.3877,
    y1: 443.5654,
    x2: 587.4502,
    y2: 443.5654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 581.39,
    y: 442.57,
    className: "st122",
    width: 6.06,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_125_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.3633,
    y1: 500.2842,
    x2: 274.5156,
    y2: 500.2842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 244.36,
    y: 499.28,
    className: "st123",
    width: 30.15,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_126_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.7041,
    y1: 500.2842,
    x2: 295.9356,
    y2: 500.2842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 285.7,
    y: 499.28,
    className: "st124",
    width: 10.23,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_127_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.8311,
    y1: 500.2842,
    x2: 238.8936,
    y2: 500.2842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 232.83,
    y: 499.28,
    className: "st125",
    width: 6.06,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_128_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.4121,
    y1: 486.9814,
    x2: 266.8106,
    y2: 486.9814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 208.41,
    y: 485.98,
    className: "st126",
    width: 58.4,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_129_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.4795,
    y1: 486.9814,
    x2: 308.2959,
    y2: 486.9814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 288.48,
    y: 485.98,
    className: "st127",
    width: 19.82,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_130_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.0772,
    y1: 486.9814,
    x2: 197.8194,
    y2: 486.9814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 186.08,
    y: 485.98,
    className: "st128",
    width: 11.74,
    height: 2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_131_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.582,
    y1: 453.627,
    x2: 150.7627,
    y2: 453.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 125.58,
    y: 452.63,
    className: "st129",
    width: 25.18,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_132_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.6817,
    y1: 453.627,
    x2: 173.5811,
    y2: 453.627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 162.68,
    y: 452.63,
    className: "st130",
    width: 10.9,
    height: 2
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_133_",
    gradientUnits: "userSpaceOnUse",
    x1: 3711.2705,
    y1: 8475.2422,
    x2: 3753.0938,
    y2: 8475.2422,
    gradientTransform: "matrix(-1 0 0 -1 3877.7559 8784.8262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M136.81,376.25c-0.02-0.13-0.17-0.27-0.17-0.4v-19.97c0-1.48,1.34-2.66,2.83-2.66l12.25-0.03 c1.48,0,2.7,1.18,2.7,2.66v20c0,0.14,0.04,0.27,0.02,0.4c7.21-3.15,12.05-10.06,12.05-18.08c0-7.9-5.51-15.86-12.07-19.71 v-86.66c0-5.02-3.56-8.88-8.58-8.88h-0.02c-5.02,0-9.19,3.86-9.19,8.88v86.66c-7.49,3.85-11.97,11.81-11.97,19.71 C124.66,366.19,129.59,373.1,136.81,376.25z M145.72,248.1c1.94,0,3.52,1.58,3.52,3.52c0,1.94-1.58,3.52-3.52,3.52 c-1.95,0-3.52-1.58-3.52-3.52C142.2,249.67,143.78,248.1,145.72,248.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_134_",
    gradientUnits: "userSpaceOnUse",
    x1: 3710.2705,
    y1: 8474.9219,
    x2: 3754.0938,
    y2: 8474.9219,
    gradientTransform: "matrix(-1 0 0 -1 3877.7559 8784.8262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M153.18,377.88l0.27-1.79c-0.02-0.06-0.03-0.16-0.03-0.25v-20c0-0.92-0.76-1.66-1.7-1.66l-12.25,0.03 c-0.98,0-1.83,0.78-1.83,1.66v19.77c0.07,0.12,0.13,0.27,0.16,0.46l0.26,1.79l-1.65-0.72c-7.74-3.38-12.74-10.83-12.74-18.99 c0-8.4,4.68-16.3,11.97-20.31v-86.05c0-5.45,4.57-9.88,10.19-9.88c5.48,0,9.6,4.25,9.6,9.88v86.09 c7.13,4.42,12.07,12.68,12.07,20.27c0,8.18-4.96,15.64-12.65,18.99L153.18,377.88z M151.71,352.18c2.04,0,3.71,1.64,3.71,3.66 v18.82c6.25-3.3,10.07-9.5,10.07-16.5c0-6.98-4.87-14.91-11.57-18.84l-0.49-0.29v-87.23c0-4.57-3.19-7.88-7.58-7.88 c-4.61,0-8.21,3.46-8.21,7.88v87.27l-0.54,0.28c-6.94,3.57-11.43,10.95-11.43,18.82c0,6.8,3.86,13.06,9.97,16.39v-18.69 c0-1.99,1.75-3.66,3.83-3.66L151.71,352.18z M145.72,256.14c-2.49,0-4.52-2.03-4.52-4.52c0-1.21,0.47-2.34,1.32-3.2 c0.85-0.85,1.99-1.32,3.19-1.32c0,0,0,0,0,0c2.49,0,4.52,2.03,4.52,4.52C150.24,254.11,148.21,256.14,145.72,256.14z  M145.72,249.1c-0.67,0-1.3,0.26-1.78,0.74c-0.48,0.48-0.74,1.11-0.74,1.78c0,1.39,1.13,2.52,2.52,2.52 c1.39,0,2.52-1.13,2.52-2.52C148.24,250.23,147.11,249.1,145.72,249.1L145.72,249.1C145.72,249.1,145.72,249.1,145.72,249.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_135_",
    gradientUnits: "userSpaceOnUse",
    x1: 585.5781,
    y1: 390.9189,
    x2: 663.0586,
    y2: 390.9189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M603.81,425.59l-10.6-10.36c-0.56-0.55-0.88-1.32-0.87-2.1c0.01-0.79,0.35-1.54,0.93-2.08l4.52-4.16 c0.21-0.19,0.26-0.5,0.13-0.74c-0.45-0.85-0.73-1.36-0.9-1.66h-8.57c-1.59,0-2.88-1.29-2.88-2.88v-13.48 c0-1.59,1.29-2.88,2.88-2.88h7.61c0.3,0,0.56-0.22,0.61-0.52c0.2-1.28,0.6-2.47,1.19-3.53c0.12-0.21,0.08-0.49-0.09-0.68 l-5.01-5.73c-0.99-1.13-0.93-2.85,0.12-3.92l9.39-9.5c0.55-0.55,1.27-0.85,2.05-0.85c0.01,0,0.01,0,0.02,0 c0.78,0.01,1.51,0.32,2.06,0.88l4.51,4.69c0.18,0.19,0.46,0.25,0.7,0.14c0.6-0.27,2.05-0.81,4.31-1.58 c0.61-0.21,1.02-0.79,1.02-1.43v-4.08c0-1.59,1.29-2.88,2.88-2.88h13.48c1.59,0,2.88,1.29,2.88,2.88v5.28 c0,0.28,0.19,0.52,0.48,0.6c0.88,0.25,1.86,0.67,2.9,1.26c0.23,0.13,0.52,0.09,0.72-0.08l5.14-4.72 c1.15-1.06,2.91-1.01,4.01,0.11l9.57,9.79c1.08,1.1,1.1,2.84,0.05,3.97l-4.82,5.18c-0.18,0.2-0.22,0.48-0.09,0.71 c0.6,1.06,1.01,2.24,1.21,3.5c0.05,0.29,0.31,0.51,0.61,0.51h4.21c1.59,0,2.88,1.29,2.88,2.88v13.48 c0,1.59-1.29,2.88-2.88,2.88H655c-0.17,0.3-0.46,0.81-0.92,1.65c-0.14,0.25-0.08,0.58,0.14,0.77l4.27,3.64 c0.61,0.52,0.98,1.28,1.01,2.08c0.03,0.8-0.28,1.59-0.85,2.15l-10.74,10.65l-1.59-1.61l10.74-10.65 c0.17-0.17,0.19-0.36,0.18-0.46c0-0.1-0.04-0.29-0.21-0.45l-4.27-3.64c-1.04-0.88-1.31-2.39-0.66-3.58 c1.55-2.82,1.55-2.82,2.28-2.82h5.8c0.34,0,0.62-0.28,0.62-0.62v-13.48c0-0.34-0.28-0.62-0.62-0.62h-4.21 c-1.42,0-2.61-1.02-2.84-2.42c-0.16-1-0.48-1.92-0.95-2.75c-0.62-1.09-0.46-2.44,0.4-3.37l4.82-5.18 c0.22-0.24,0.22-0.62-0.01-0.85l-9.57-9.79c-0.24-0.24-0.61-0.25-0.86-0.02l-5.14,4.72c-0.92,0.84-2.26,1-3.35,0.39 c-0.89-0.5-1.7-0.86-2.42-1.06c-1.27-0.36-2.12-1.48-2.12-2.78v-5.28c0-0.34-0.28-0.62-0.62-0.62h-13.48 c-0.34,0-0.62,0.28-0.62,0.62v4.08c0,1.61-1.02,3.05-2.55,3.57c-2.13,0.73-3.59,1.26-4.11,1.5c-1.11,0.5-2.42,0.25-3.26-0.63 l-4.51-4.69c-0.16-0.17-0.32-0.21-0.45-0.19c-0.1,0-0.28,0.02-0.44,0.18l-9.39,9.49c-0.23,0.23-0.24,0.6-0.03,0.84l5.01,5.73 c0.8,0.91,0.94,2.22,0.36,3.27c-0.46,0.83-0.78,1.77-0.93,2.78c-0.22,1.41-1.42,2.43-2.84,2.43h-7.61 c-0.34,0-0.62,0.28-0.62,0.62v13.48c0,0.34,0.28,0.62,0.62,0.62h9.2c0.74,0,0.74,0,2.26,2.86c0.62,1.16,0.37,2.58-0.59,3.47 l-4.52,4.16c-0.17,0.16-0.2,0.35-0.2,0.45c0,0.1,0.02,0.29,0.19,0.45l10.6,10.36L603.81,425.59z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M618.85,422.38h14.44v-7.34l0.73-0.28c8.67-3.33,14.27-11.51,14.27-20.85c0-12.4-10.05-22.49-22.4-22.49 c-12.38,0-22.45,10.09-22.45,22.49c0,9.51,5.76,17.77,14.68,21.05l0.74,0.27V422.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_136_",
    gradientUnits: "userSpaceOnUse",
    x1: 602.4297,
    y1: 396.8965,
    x2: 649.2764,
    y2: 396.8965
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M634.29,423.38h-16.44v-7.45l-0.09-0.03c-9.31-3.43-15.33-12.06-15.33-21.99 c0-12.96,10.52-23.49,23.45-23.49c12.9,0,23.4,10.54,23.4,23.49c0,9.76-5.85,18.31-14.91,21.78l-0.08,0.03V423.38z  M619.85,421.38h12.44v-7.03l1.37-0.52c8.28-3.18,13.62-11,13.62-19.92c0-11.85-9.6-21.49-21.4-21.49 c-11.83,0-21.45,9.64-21.45,21.49c0,9.08,5.5,16.98,14.02,20.11l1.39,0.51V421.38z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M631.09,396.81c0-2.54-2.06-4.6-4.6-4.6c-2.54,0-4.6,2.06-4.6,4.6c0,1.93,1.2,3.58,2.89,4.26v23.96h2.72 v-23.74C629.56,400.82,631.09,398.99,631.09,396.81z M626.49,398.69c-1.03,0-1.88-0.84-1.88-1.88c0-1.04,0.84-1.88,1.88-1.88 c1.04,0,1.88,0.84,1.88,1.88C628.37,397.84,627.53,398.69,626.49,398.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M628.51,426.03h-4.72V401.7c-1.78-0.98-2.89-2.83-2.89-4.89c0-3.09,2.51-5.6,5.6-5.6 c3.09,0,5.6,2.51,5.6,5.6c0,2.35-1.44,4.39-3.58,5.21V426.03z M625.79,424.03h0.72v-23.54l0.78-0.18c1.62-0.37,2.8-1.84,2.8-3.5 c0-1.98-1.61-3.6-3.6-3.6c-1.98,0-3.6,1.61-3.6,3.6c0,1.47,0.89,2.78,2.27,3.33l0.63,0.25V424.03z M626.49,399.69 c-1.59,0-2.88-1.29-2.88-2.88c0-1.59,1.29-2.88,2.88-2.88c1.59,0,2.88,1.29,2.88,2.88C629.37,398.4,628.08,399.69,626.49,399.69 z M626.49,395.93c-0.48,0-0.88,0.39-0.88,0.88s0.39,0.88,0.88,0.88c0.48,0,0.88-0.39,0.88-0.88S626.98,395.93,626.49,395.93z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_137_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.5117,
    y1: 427.0865,
    x2: 637.1953,
    y2: 427.0865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M617.21,421.17c-1.49,0-2.69,1.21-2.69,2.69v6.45c0,1.49,1.21,2.69,2.69,2.69h17.29 c1.49,0,2.69-1.21,2.69-2.69v-6.45c0-1.49-1.21-2.69-2.69-2.69H617.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_138_",
    gradientUnits: "userSpaceOnUse",
    x1: 613.5117,
    y1: 427.0865,
    x2: 638.1953,
    y2: 427.0865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M634.5,434.01h-17.29c-2.04,0-3.69-1.66-3.69-3.69v-6.45c0-2.04,1.66-3.69,3.69-3.69h17.29 c2.04,0,3.69,1.66,3.69,3.69v6.45C638.2,432.35,636.54,434.01,634.5,434.01z M617.21,422.17c-0.93,0-1.69,0.76-1.69,1.69v6.45 c0,0.93,0.76,1.69,1.69,1.69h17.29c0.93,0,1.69-0.76,1.69-1.69v-6.45c0-0.93-0.76-1.69-1.69-1.69H617.21z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_139_",
    gradientUnits: "userSpaceOnUse",
    x1: -1938.8596,
    y1: 5021.916,
    x2: -1919.8688,
    y2: 5021.916,
    gradientTransform: "matrix(0 1 -1 0 5390.9922 2044.6097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M361.58,115.32v-0.15c0-0.46,0.13-0.9,0.39-1.26c0.3-0.43,0.74-0.73,1.24-0.87l9.92-6.9 c1.01-0.69,2.38-0.44,3.07,0.55c0.67,0.97,0.4,2.4-0.56,3.06l-7.89,5.49l7.89,5.49c0.96,0.66,1.22,2.09,0.56,3.06 c-0.69,1-2.07,1.25-3.07,0.56l-9.92-6.9c-0.5-0.13-0.94-0.44-1.24-0.87C361.71,116.21,361.58,115.78,361.58,115.32z  M363.58,115.3l-1,0.02h1c0,0.07,0.02,0.1,0.03,0.12c0.03,0.04,0.07,0.07,0.13,0.08l0.24,0.03l10.29,7.16 c0.09,0.06,0.22,0.04,0.29-0.05c0.04-0.06,0.13-0.16-0.05-0.28l-10.26-7.13l10.26-7.13c0.18-0.12,0.09-0.22,0.05-0.28 c-0.06-0.09-0.19-0.11-0.29-0.04l-10.28,7.15l-0.24,0.03c-0.04,0-0.1,0.02-0.14,0.08c-0.01,0.01-0.03,0.04-0.03,0.12V115.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_140_",
    gradientUnits: "userSpaceOnUse",
    x1: -1938.8596,
    y1: 5011.1196,
    x2: -1919.8672,
    y2: 5011.1196,
    gradientTransform: "matrix(0 1 -1 0 5390.9922 2044.6097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M372.38,115.33v-0.16c0-0.46,0.14-0.89,0.39-1.26c0.3-0.43,0.74-0.73,1.24-0.87l9.92-6.9 c1-0.69,2.38-0.44,3.07,0.55c0.67,0.96,0.41,2.4-0.55,3.06l-7.9,5.49l7.9,5.49c0.96,0.67,1.22,2.1,0.55,3.07 c-0.33,0.48-0.83,0.8-1.41,0.91s-1.17-0.02-1.65-0.36l-9.92-6.9c-0.5-0.13-0.94-0.44-1.24-0.87 C372.51,116.21,372.38,115.78,372.38,115.33z M374.38,115.31l-1,0.02h1c0,0.06,0.02,0.09,0.03,0.12 c0.04,0.06,0.1,0.07,0.13,0.08l0.24,0.03l10.29,7.16c0.06,0.04,0.11,0.04,0.15,0.03c0.04-0.01,0.09-0.03,0.13-0.08 c0.05-0.07,0.13-0.16-0.04-0.28l-10.27-7.13l10.26-7.13c0.17-0.12,0.09-0.21,0.05-0.28c-0.07-0.09-0.19-0.12-0.29-0.05 l-10.28,7.15l-0.24,0.03c-0.03,0.01-0.1,0.02-0.14,0.08c-0.01,0.01-0.03,0.04-0.03,0.11L374.38,115.31z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_141_",
    gradientUnits: "userSpaceOnUse",
    x1: -1939.3196,
    y1: 5000.3237,
    x2: -1920.3307,
    y2: 5000.3237,
    gradientTransform: "matrix(0 1 -1 0 5390.9922 2044.6097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M383.17,114.87v-0.17c0-0.46,0.14-0.89,0.39-1.26c0.29-0.42,0.73-0.73,1.24-0.86l9.92-6.9 c1.01-0.69,2.39-0.44,3.07,0.56c0.67,0.96,0.41,2.39-0.55,3.06l-7.9,5.49l7.9,5.48c0.96,0.67,1.22,2.1,0.55,3.06 c-0.69,1-2.07,1.25-3.07,0.55l-9.92-6.9c-0.5-0.13-0.95-0.44-1.24-0.87C383.31,115.76,383.17,115.33,383.17,114.87z  M385.17,114.85l-1,0.02h1c0,0.06,0.02,0.09,0.03,0.11c0.04,0.06,0.1,0.08,0.14,0.08l0.24,0.03l10.28,7.15 c0.09,0.06,0.22,0.04,0.29-0.05c0.04-0.06,0.13-0.16-0.05-0.28l-10.26-7.13l10.26-7.13c0.18-0.12,0.09-0.22,0.05-0.28 c-0.07-0.1-0.2-0.12-0.3-0.05l-10.27,7.14l-0.24,0.03c-0.03,0-0.1,0.02-0.13,0.08c-0.02,0.03-0.03,0.06-0.03,0.11 L385.17,114.85z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_142_",
    gradientUnits: "userSpaceOnUse",
    x1: -1939.3212,
    y1: 4989.5264,
    x2: -1920.3287,
    y2: 4989.5264,
    gradientTransform: "matrix(0 1 -1 0 5390.9922 2044.6097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M393.97,114.87v-0.18c0-0.44,0.13-0.87,0.38-1.24c0.31-0.44,0.75-0.74,1.25-0.88l9.93-6.9 c1-0.69,2.38-0.44,3.07,0.55c0.67,0.96,0.41,2.4-0.55,3.07l-7.89,5.49l7.89,5.48c0.96,0.67,1.22,2.1,0.55,3.06 c-0.34,0.48-0.84,0.81-1.42,0.91c-0.58,0.11-1.17-0.02-1.65-0.36l-9.93-6.9c-0.5-0.13-0.94-0.44-1.24-0.86 C394.1,115.74,393.97,115.32,393.97,114.87z M395.97,114.86l-1,0.02h1c0,0.04,0.01,0.08,0.04,0.12 c0.02,0.03,0.07,0.06,0.13,0.07l0.24,0.03l10.29,7.15c0.08,0.06,0.23,0.03,0.29-0.05c0.04-0.06,0.13-0.16-0.05-0.28 l-10.26-7.13l10.26-7.13c0.18-0.12,0.09-0.22,0.05-0.28c-0.06-0.09-0.19-0.12-0.29-0.05l-10.29,7.15l-0.24,0.03 c-0.04,0-0.1,0.02-0.14,0.08c-0.01,0.02-0.03,0.06-0.03,0.1V114.86z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M89.84,289.89h-3.67l-1.46-3.79h-6.67l-1.38,3.79H73.1l6.5-16.69h3.56L89.84,289.89z M83.64,283.29 l-2.3-6.19l-2.25,6.19H83.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M91.47,289.89v-16.69h3.2v6.01c0.99-1.12,2.16-1.69,3.51-1.69c1.47,0,2.69,0.53,3.65,1.6 c0.96,1.07,1.45,2.6,1.45,4.59c0,2.06-0.49,3.65-1.47,4.77c-0.98,1.12-2.18,1.67-3.58,1.67c-0.69,0-1.37-0.17-2.04-0.52 c-0.67-0.35-1.25-0.86-1.74-1.53v1.78H91.47z M94.65,283.59c0,1.25,0.2,2.18,0.59,2.78c0.55,0.85,1.29,1.27,2.21,1.27 c0.71,0,1.31-0.3,1.8-0.91c0.5-0.6,0.75-1.55,0.75-2.85c0-1.38-0.25-2.38-0.75-2.99c-0.5-0.61-1.14-0.92-1.92-0.92 c-0.77,0-1.4,0.3-1.91,0.89C94.9,281.47,94.65,282.37,94.65,283.59z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st143",
    d: "M116.39,281.38l-3.15,0.57c-0.11-0.63-0.35-1.1-0.72-1.42c-0.38-0.32-0.86-0.48-1.46-0.48 c-0.8,0-1.43,0.27-1.91,0.83c-0.47,0.55-0.71,1.47-0.71,2.76c0,1.43,0.24,2.45,0.72,3.04c0.48,0.59,1.13,0.89,1.94,0.89 c0.61,0,1.1-0.17,1.49-0.52c0.39-0.34,0.66-0.94,0.82-1.78l3.14,0.54c-0.33,1.44-0.95,2.53-1.88,3.27 c-0.93,0.74-2.17,1.1-3.72,1.1c-1.77,0-3.18-0.56-4.23-1.67c-1.05-1.12-1.58-2.66-1.58-4.63c0-2,0.53-3.55,1.58-4.66 c1.05-1.11,2.48-1.67,4.28-1.67c1.47,0,2.64,0.32,3.51,0.95C115.38,279.12,116.01,280.08,116.39,281.38z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_143_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.6572,
    y1: 266.312,
    x2: 596.7754,
    y2: 266.312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st144",
    d: "M593.86,255.12c-0.71,0.21-1.26,0.51-1.63,0.87c-0.38,0.38-0.63,0.86-0.77,1.47 c-0.14,0.61-0.21,1.67-0.21,3.2c0,0.94-0.03,1.6-0.1,1.98c-0.08,0.5-0.22,0.92-0.43,1.26c-0.21,0.33-0.47,0.57-0.76,0.72 c-0.29,0.14-0.73,0.22-1.3,0.26v2.84c0.73,0.04,1.26,0.19,1.62,0.47c0.36,0.27,0.62,0.72,0.79,1.36 c0.12,0.44,0.19,1.38,0.19,2.83c0,1.25,0.06,2.17,0.2,2.75c0.13,0.58,0.4,1.07,0.79,1.46c0.39,0.4,0.87,0.68,1.44,0.85 c0.57,0.17,1.39,0.26,2.47,0.26h0.63v-2.85c-0.85,0-1.41-0.05-1.66-0.16c-0.25-0.11-0.45-0.26-0.57-0.48 c-0.12-0.2-0.18-0.56-0.18-1.08c0-0.36-0.03-1.2-0.1-2.51c-0.04-0.87-0.15-1.56-0.3-2.07c-0.16-0.51-0.38-0.95-0.69-1.31 c-0.29-0.35-0.68-0.67-1.14-0.94c0.53-0.34,0.92-0.67,1.18-0.99c0.25-0.31,0.47-0.71,0.63-1.19c0.16-0.49,0.27-1.12,0.31-1.91 c0.07-1.38,0.11-2.33,0.11-2.83c0-0.48,0.06-0.83,0.17-1.03c0.12-0.21,0.3-0.36,0.56-0.46c0.24-0.1,0.81-0.15,1.69-0.15v-2.83 h-0.63C595.11,254.91,594.35,254.98,593.86,255.12z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_144_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.6221,
    y1: 266.3066,
    x2: 615.75,
    y2: 266.3066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st145",
    d: "M615.74,267.73v-2.84c-0.73-0.04-1.27-0.2-1.62-0.48c-0.35-0.27-0.62-0.73-0.8-1.35 c-0.12-0.45-0.18-1.38-0.18-2.83c0-1.25-0.06-2.16-0.2-2.74c-0.14-0.59-0.41-1.08-0.79-1.48c-0.38-0.39-0.87-0.67-1.44-0.85 c-0.58-0.16-1.39-0.25-2.46-0.25h-0.64v2.83c0.9,0,1.48,0.06,1.73,0.16c0.26,0.11,0.45,0.26,0.54,0.45 c0.1,0.2,0.15,0.6,0.16,1.19c0.04,1.89,0.11,3.1,0.19,3.66c0.13,0.8,0.39,1.46,0.76,1.99c0.27,0.36,0.7,0.73,1.28,1.11 c-0.46,0.25-0.82,0.56-1.11,0.91c-0.29,0.33-0.51,0.76-0.69,1.25c-0.17,0.49-0.28,1.15-0.32,1.97c-0.06,1.37-0.1,2.28-0.1,2.77 c-0.01,0.48-0.07,0.83-0.19,1.03c-0.12,0.2-0.31,0.35-0.57,0.46c-0.26,0.1-0.82,0.15-1.67,0.15v2.85h0.64 c1.03,0,1.8-0.07,2.27-0.21c0.72-0.21,1.27-0.5,1.65-0.87c0.37-0.36,0.63-0.86,0.76-1.46c0.14-0.62,0.21-1.69,0.21-3.22 c0-0.94,0.03-1.6,0.1-1.97c0.08-0.51,0.23-0.93,0.45-1.26c0.2-0.33,0.46-0.58,0.75-0.72 C614.74,267.85,615.16,267.76,615.74,267.73L615.74,267.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_145_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.3721,
    y1: 262.7095,
    x2: 607.0176,
    y2: 262.7095
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 597.37,
    y: 261.43,
    className: "st146",
    width: 9.65,
    height: 2.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_146_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.3721,
    y1: 266.3071,
    x2: 607.0176,
    y2: 266.3071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 597.37,
    y: 265.03,
    className: "st147",
    width: 9.65,
    height: 2.56
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_147_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.3721,
    y1: 269.9038,
    x2: 602.9678,
    y2: 269.9038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 597.37,
    y: 268.62,
    className: "st148",
    width: 5.6,
    height: 2.56
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1050_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_148_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.1563,
    y1: 242.1275,
    x2: 551.919,
    y2: 242.1275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 494.16,
    y: 227.88,
    className: "st149",
    width: 57.76,
    height: 28.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_149_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.6563,
    y1: 242.127,
    x2: 552.419,
    y2: 242.127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st150",
    d: "M552.42,256.88h-58.76v-29.5h58.76V256.88z M494.66,255.88h56.76v-27.5h-56.76V255.88z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M513.39,247.06c-0.59,0.29-1.77,0.59-3.28,0.59c-3.5,0-6.13-2.21-6.13-6.28 c0-3.89,2.63-6.52,6.48-6.52c1.55,0,2.52,0.33,2.95,0.55l-0.39,1.31c-0.61-0.29-1.47-0.52-2.51-0.52 c-2.91,0-4.84,1.86-4.84,5.12c0,3.04,1.75,4.99,4.77,4.99c0.98,0,1.97-0.2,2.62-0.52L513.39,247.06z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M515.17,245.51c0.72,0.44,1.77,0.81,2.87,0.81c1.64,0,2.6-0.87,2.6-2.12c0-1.16-0.66-1.82-2.34-2.47 c-2.03-0.72-3.28-1.77-3.28-3.52c0-1.93,1.6-3.37,4.01-3.37c1.27,0,2.19,0.29,2.74,0.61l-0.44,1.31 c-0.4-0.22-1.23-0.59-2.36-0.59c-1.69,0-2.34,1.01-2.34,1.86c0,1.16,0.75,1.73,2.47,2.39c2.1,0.81,3.17,1.82,3.17,3.65 c0,1.92-1.42,3.57-4.35,3.57c-1.2,0-2.5-0.35-3.17-0.79L515.17,245.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M524.25,245.51c0.72,0.44,1.77,0.81,2.87,0.81c1.64,0,2.6-0.87,2.6-2.12c0-1.16-0.66-1.82-2.34-2.47 c-2.03-0.72-3.28-1.77-3.28-3.52c0-1.93,1.6-3.37,4.02-3.37c1.27,0,2.19,0.29,2.74,0.61l-0.44,1.31 c-0.41-0.22-1.23-0.59-2.36-0.59c-1.69,0-2.34,1.01-2.34,1.86c0,1.16,0.75,1.73,2.47,2.39c2.1,0.81,3.17,1.82,3.17,3.65 c0,1.92-1.42,3.57-4.35,3.57c-1.2,0-2.5-0.35-3.17-0.79L524.25,245.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M533.36,245.6c0.46,0.29,1.53,0.75,2.65,0.75c2.08,0,2.72-1.33,2.71-2.32 c-0.02-1.68-1.53-2.39-3.09-2.39h-0.9v-1.22h0.9c1.18,0,2.67-0.61,2.67-2.03c0-0.96-0.61-1.8-2.1-1.8 c-0.96,0-1.88,0.42-2.39,0.79l-0.42-1.18c0.63-0.46,1.84-0.92,3.13-0.92c2.36,0,3.43,1.4,3.43,2.85 c0,1.23-0.74,2.28-2.21,2.82V241c1.47,0.29,2.67,1.4,2.67,3.08c0,1.92-1.49,3.59-4.36,3.59c-1.34,0-2.52-0.42-3.11-0.81 L533.36,245.6z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_150_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.2861,
    y1: 319.8047,
    x2: 625.7471,
    y2: 319.8047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 588.29,
    y: 313.06,
    className: "st151",
    width: 37.46,
    height: 13.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_151_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.7861,
    y1: 319.8052,
    x2: 626.2471,
    y2: 319.8052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st152",
    d: "M626.25,327.05h-38.46v-14.48h38.46V327.05z M588.79,326.05h36.46v-12.48h-36.46V326.05z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M595.96,316.58v2.39h2.76v-2.39h0.75v5.71h-0.75v-2.68h-2.76v2.68h-0.74v-5.71H595.96z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M601.83,317.21h-1.74v-0.63h4.23v0.63h-1.74v5.08h-0.75V317.21z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M609.76,319.78c-0.04-0.8-0.09-1.75-0.09-2.46h-0.03c-0.19,0.67-0.43,1.38-0.72,2.17l-1.01,2.77h-0.56 l-0.92-2.72c-0.27-0.8-0.5-1.54-0.66-2.22h-0.02c-0.02,0.71-0.06,1.67-0.11,2.52l-0.15,2.45h-0.7l0.4-5.71h0.94l0.97,2.76 c0.24,0.7,0.43,1.33,0.58,1.92h0.03c0.14-0.58,0.35-1.2,0.6-1.92l1.02-2.76h0.94l0.36,5.71h-0.72L609.76,319.78z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M611.76,316.58h0.74v5.09h2.44v0.62h-3.18V316.58z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M618.78,317.41h-2.1l-0.21,1.41c0.13-0.02,0.25-0.03,0.45-0.03c0.42,0,0.85,0.09,1.19,0.3 c0.43,0.25,0.79,0.72,0.79,1.41c0,1.08-0.85,1.88-2.05,1.88c-0.6,0-1.11-0.17-1.37-0.34l0.19-0.57 c0.23,0.13,0.68,0.3,1.18,0.3c0.7,0,1.3-0.46,1.3-1.19c-0.01-0.71-0.48-1.22-1.58-1.22c-0.31,0-0.56,0.03-0.76,0.06 l0.36-2.64h2.63V317.41z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M190.21,246.16v155.71c0,6.94,5.62,12.56,12.56,12.56h235.59c6.94,0,12.56-5.62,12.56-12.56V246.16 c0-6.94-5.62-12.56-12.56-12.56H202.77C195.83,233.6,190.21,239.22,190.21,246.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_152_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.208,
    y1: 324.0146,
    x2: 451.9248,
    y2: 324.0146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st153",
    d: "M438.36,415.43H202.77c-7.48,0-13.56-6.08-13.56-13.56V246.16c0-7.48,6.08-13.56,13.56-13.56h235.59 c7.48,0,13.56,6.08,13.56,13.56v155.71C451.92,409.35,445.84,415.43,438.36,415.43z M202.77,234.6 c-6.38,0-11.56,5.19-11.56,11.56v155.71c0,6.38,5.19,11.56,11.56,11.56h235.59c6.37,0,11.56-5.19,11.56-11.56V246.16 c0-6.37-5.19-11.56-11.56-11.56H202.77z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M200.44,246.16v155.71c0,6.94,5.62,12.56,12.56,12.56H448.6c6.94,0,12.56-5.62,12.56-12.56V246.16 c0-6.94-5.62-12.56-12.56-12.56H213C206.07,233.6,200.44,239.22,200.44,246.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_153_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.4424,
    y1: 324.0146,
    x2: 462.1592,
    y2: 324.0146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st154",
    d: "M448.6,415.43H213c-7.48,0-13.56-6.08-13.56-13.56V246.16c0-7.48,6.08-13.56,13.56-13.56H448.6 c7.48,0,13.56,6.08,13.56,13.56v155.71C462.16,409.35,456.08,415.43,448.6,415.43z M213,234.6c-6.38,0-11.56,5.19-11.56,11.56 v155.71c0,6.38,5.19,11.56,11.56,11.56H448.6c6.37,0,11.56-5.19,11.56-11.56V246.16c0-6.37-5.19-11.56-11.56-11.56H213z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_154_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.1074,
    y1: 324.0137,
    x2: 447.9033,
    y2: 324.0137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2579,
    style: {
      stopColor: "#35C2F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5049,
    style: {
      stopColor: "#5F8EED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    style: {
      stopColor: "#7D69E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    style: {
      stopColor: "#8F52E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 212.11,
    y: 247.99,
    className: "st155",
    width: 235.8,
    height: 152.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_155_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.1074,
    y1: 324.0146,
    x2: 448.9033,
    y2: 324.0146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st156",
    d: "M448.9,401.04h-237.8V246.99h237.8V401.04z M213.11,399.04h233.8V248.99h-233.8V399.04z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_156_",
    gradientUnits: "userSpaceOnUse",
    x1: 1976.9346,
    y1: -1861.7874,
    x2: 2268.002,
    y2: -1861.7874,
    gradientTransform: "matrix(0 -1 1 0 2191.7922 2375.8438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03FBFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#29FCFC",
      stopOpacity: 0.8725
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4505,
    style: {
      stopColor: "#83FDFE",
      stopOpacity: 0.5495
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    style: {
      stopColor: "#C6FEFE",
      stopOpacity: 0.2867
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9028,
    style: {
      stopColor: "#EFFFFF",
      stopOpacity: 0.0972
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st157",
    points: "512.03,107.84 446.12,398.91 213.89,398.91 147.98,107.84  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M561.59,422.96c0-4.71-3.82-8.52-8.52-8.52H324.2c-6.47,0-11.77,3.83-11.77,8.52 c0,4.7,5.29,8.53,11.77,8.53h228.87C557.77,431.48,561.59,427.67,561.59,422.96L561.59,422.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_157_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.4336,
    y1: 422.9604,
    x2: 562.5899,
    y2: 422.9604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st158",
    d: "M553.07,432.48H324.2c-7.04,0-12.77-4.28-12.77-9.53c0-5.25,5.73-9.52,12.77-9.52h228.87 c5.25,0,9.52,4.27,9.52,9.52C562.59,428.21,558.32,432.48,553.07,432.48z M324.2,415.44c-5.94,0-10.77,3.37-10.77,7.52 c0,4.15,4.83,7.53,10.77,7.53h228.87c4.15,0,7.52-3.38,7.52-7.52c0-4.15-3.38-7.52-7.52-7.52H324.2z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M473.97,414.75v0.73c0,2.66-2.17,4.82-4.83,4.82h-72.05c-2.65,0-4.82-2.15-4.82-4.82v-0.73H473.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st159",
    d: "M469.14,421.29h-72.05c-3.21,0-5.82-2.61-5.82-5.82v-1.73h83.7v1.73 C474.97,418.68,472.36,421.29,469.14,421.29z M393.29,415.75c0.14,1.98,1.79,3.54,3.81,3.54h72.05c2.02,0,3.68-1.57,3.82-3.54 H393.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M337.99,422.95c0,4.7-4.13,8.53-9.19,8.53H211.54c-5.05,0-9.18-3.83-9.18-8.53 c0-4.69,4.13-8.52,9.18-8.52H328.8C333.86,414.44,337.99,418.27,337.99,422.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_158_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.3623,
    y1: 422.9604,
    x2: 338.9912,
    y2: 422.9604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M328.8,432.48H211.54c-5.61,0-10.18-4.28-10.18-9.53c0-5.25,4.57-9.52,10.18-9.52H328.8 c5.62,0,10.19,4.27,10.19,9.52C338.99,428.21,334.42,432.48,328.8,432.48z M211.54,415.44c-4.51,0-8.18,3.37-8.18,7.52 c0,4.15,3.67,7.53,8.18,7.53H328.8c4.52,0,8.19-3.38,8.19-7.53c0-4.15-3.67-7.52-8.19-7.52H211.54z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_159_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.4512,
    y1: 421.3886,
    x2: 292.7451,
    y2: 421.3886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M291.06,423.07h-10.92c-0.93,0-1.68-0.76-1.68-1.68l0,0c0-0.93,0.76-1.69,1.68-1.69h10.92 c0.93,0,1.68,0.76,1.68,1.69l0,0C292.75,422.32,291.99,423.07,291.06,423.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_160_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.2861,
    y1: 421.3886,
    x2: 319.5801,
    y2: 421.3886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st162",
    d: "M317.9,423.07h-10.92c-0.93,0-1.68-0.76-1.68-1.68l0,0c0-0.93,0.76-1.69,1.68-1.69h10.92 c0.93,0,1.68,0.76,1.68,1.69l0,0C319.58,422.32,318.82,423.07,317.9,423.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_161_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.8418,
    y1: 269.6513,
    x2: 432.9219,
    y2: 269.6513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 234.84,
    y: 141.45,
    className: "st163",
    width: 198.08,
    height: 256.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_162_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.8418,
    y1: 269.6513,
    x2: 433.9219,
    y2: 269.6513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st164",
    d: "M433.92,398.86H233.84V140.45h200.08V398.86z M235.84,396.86h196.08V142.45H235.84V396.86z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_580_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_163_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.2471,
    y1: 158.1011,
    x2: 338.249,
    y2: 158.1011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 156.31,
    className: "st165",
    width: 91,
    height: 3.58
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 165.15,
    className: "st166",
    width: 18.43,
    height: 3.58
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 173.97,
    className: "st167",
    width: 39.39,
    height: 3.57
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2717_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 182.8,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2716_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 191.62,
    className: "st166",
    width: 32.21,
    height: 3.57
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2715_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 200.45,
    className: "st166",
    width: 31.32,
    height: 3.58
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2714_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.19,
    y: 165.15,
    className: "st167",
    width: 58.36,
    height: 3.58
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2713_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 343.87,
    y: 165.15,
    className: "st167",
    width: 27.87,
    height: 3.58
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2712_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 382.32,
    y: 165.15,
    className: "st167",
    width: 37.62,
    height: 3.58
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2711_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.86,
    y: 173.97,
    className: "st166",
    width: 32.83,
    height: 3.57
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2710_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 182.8,
    className: "st167",
    width: 18.8,
    height: 3.58
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2709_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 191.62,
    className: "st167",
    width: 32.2,
    height: 3.57
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2708_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 326.91,
    y: 182.8,
    className: "st167",
    width: 35.78,
    height: 3.58
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2707_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.85,
    y: 182.8,
    className: "st167",
    width: 18.77,
    height: 3.58
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2706_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.69,
    y: 182.8,
    className: "st167",
    width: 23.26,
    height: 3.58
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2705_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 338.53,
    y: 191.62,
    className: "st167",
    width: 40.67,
    height: 3.57
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2704_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.27,
    y: 191.62,
    className: "st167",
    width: 12.15,
    height: 3.57
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2703_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.75,
    y: 200.45,
    className: "st167",
    width: 23.29,
    height: 3.58
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2702_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 218.11,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2701_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 226.94,
    className: "st166",
    width: 32.21,
    height: 3.57
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2700_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 218.11,
    className: "st167",
    width: 18.8,
    height: 3.58
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2699_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 226.94,
    className: "st167",
    width: 29,
    height: 3.57
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2698_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 326.91,
    y: 218.11,
    className: "st167",
    width: 27.52,
    height: 3.58
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2697_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.92,
    y: 218.11,
    className: "st167",
    width: 14.46,
    height: 3.58
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2696_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 380.58,
    y: 218.11,
    className: "st167",
    width: 17.89,
    height: 3.58
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2695_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 356.39,
    y: 226.94,
    className: "st167",
    width: 32.23,
    height: 3.57
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2694_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 235.76,
    className: "st166",
    width: 32.21,
    height: 3.57
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2693_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 244.6,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2692_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 235.76,
    className: "st167",
    width: 18.8,
    height: 3.57
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2691_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 244.6,
    className: "st167",
    width: 59.04,
    height: 3.58
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2690_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 326.91,
    y: 235.76,
    className: "st167",
    width: 35.78,
    height: 3.57
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2689_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.85,
    y: 235.76,
    className: "st167",
    width: 18.77,
    height: 3.57
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2688_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.69,
    y: 235.76,
    className: "st167",
    width: 23.26,
    height: 3.57
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2687_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.36,
    y: 244.6,
    className: "st167",
    width: 33.11,
    height: 3.58
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2686_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 334.62,
    y: 226.94,
    className: "st167",
    width: 13.71,
    height: 3.57
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 262.25,
    className: "st166",
    width: 18.43,
    height: 3.57
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 271.06,
    className: "st167",
    width: 39.39,
    height: 3.57
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2683_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 279.9,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2682_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 288.72,
    className: "st166",
    width: 32.21,
    height: 3.6
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2681_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 297.55,
    className: "st166",
    width: 31.32,
    height: 3.58
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2680_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.19,
    y: 262.25,
    className: "st167",
    width: 32.38,
    height: 3.58
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2679_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 262.25,
    className: "st167",
    width: 16.35,
    height: 3.58
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2678_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 262.25,
    className: "st167",
    width: 52.01,
    height: 3.58
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2677_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.86,
    y: 271.06,
    className: "st166",
    width: 32.83,
    height: 3.57
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2676_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 279.9,
    className: "st167",
    width: 36.69,
    height: 3.58
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2675_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 288.72,
    className: "st167",
    width: 25.05,
    height: 3.6
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2674_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 279.9,
    className: "st167",
    width: 27.27,
    height: 3.58
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2673_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.37,
    y: 288.72,
    className: "st167",
    width: 47.83,
    height: 3.6
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2672_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.27,
    y: 288.72,
    className: "st167",
    width: 12.15,
    height: 3.6
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2671_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.75,
    y: 297.55,
    className: "st167",
    width: 23.29,
    height: 3.58
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2670_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.2,
    y: 297.55,
    className: "st167",
    width: 43.34,
    height: 3.58
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2669_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 297.55,
    className: "st167",
    width: 12.95,
    height: 3.58
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2668_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 315.2,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2667_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 324.04,
    className: "st166",
    width: 32.21,
    height: 3.58
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2666_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 315.2,
    className: "st167",
    width: 53.02,
    height: 3.58
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2665_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 324.04,
    className: "st167",
    width: 29,
    height: 3.58
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2664_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.92,
    y: 315.2,
    className: "st167",
    width: 14.46,
    height: 3.58
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2663_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 380.58,
    y: 315.2,
    className: "st167",
    width: 17.89,
    height: 3.58
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2662_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 356.39,
    y: 324.04,
    className: "st167",
    width: 32.23,
    height: 3.58
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2661_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 334.62,
    y: 324.04,
    className: "st167",
    width: 13.71,
    height: 3.58
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 338.52,
    className: "st166",
    width: 18.43,
    height: 3.57
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 347.33,
    className: "st167",
    width: 39.39,
    height: 3.57
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2658_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 356.17,
    className: "st166",
    width: 32.21,
    height: 3.57
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2657_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.13,
    y: 364.99,
    className: "st166",
    width: 32.21,
    height: 3.57
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2656_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.48,
    y: 373.82,
    className: "st166",
    width: 31.32,
    height: 3.57
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2655_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.19,
    y: 338.52,
    className: "st167",
    width: 32.38,
    height: 3.57
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2654_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.86,
    y: 338.52,
    className: "st167",
    width: 16.35,
    height: 3.57
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2633_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 338.52,
    className: "st167",
    width: 75.15,
    height: 3.57
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2632_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 295.86,
    y: 347.33,
    className: "st166",
    width: 32.83,
    height: 3.57
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2631_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 356.17,
    className: "st167",
    width: 36.69,
    height: 3.57
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2630_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 364.99,
    className: "st167",
    width: 25.05,
    height: 3.57
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2629_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 344.8,
    y: 356.17,
    className: "st167",
    width: 27.27,
    height: 3.57
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2628_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.22,
    y: 356.17,
    className: "st167",
    width: 16.58,
    height: 3.57
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2627_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 403.87,
    y: 356.17,
    className: "st167",
    width: 16.08,
    height: 3.57
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2626_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 331.37,
    y: 364.99,
    className: "st167",
    width: 47.83,
    height: 3.57
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2567_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 385.27,
    y: 364.99,
    className: "st167",
    width: 12.15,
    height: 3.57
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2505_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.75,
    y: 373.82,
    className: "st167",
    width: 23.29,
    height: 3.57
  })))))), /*#__PURE__*/React.createElement("g", null, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_581_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M183.07,372.25l6.86,1.42l3-14.48l-6.86-1.42c0.12-5.78-1-11.38-3.16-16.51l5.86-3.85l-8.12-12.36 l-5.86,3.85c-3.03-3.16-6.6-5.85-10.59-7.92c-1.03-0.54-2.1-1.03-3.19-1.48c-0.04-0.02-0.09-0.03-0.13-0.05l1.43-6.87 l-14.48-3l-1.42,6.87c-1.52-0.03-3.02,0.02-4.51,0.16c-4.18,0.38-8.23,1.4-12.01,3l-3.85-5.86l-12.35,8.12l3.85,5.85 c-4.02,3.85-7.26,8.56-9.45,13.91l-6.86-1.42l-3,14.48l6.86,1.42c-0.12,5.78,0.99,11.39,3.15,16.52l-5.85,3.85l8.12,12.36 l5.86-3.85c3.85,4.02,8.56,7.27,13.91,9.45l-1.42,6.87l14.47,2.99l1.42-6.86c1.53,0.03,3.03-0.02,4.52-0.15 c4.18-0.38,8.22-1.41,12-3l3.85,5.86l12.35-8.13l-3.84-5.85C177.64,382.3,180.89,377.6,183.07,372.25z M148.3,386.73 c-2.86,0.26-5.82,0.11-8.78-0.5c-16.17-3.34-26.58-19.17-23.23-35.34c2.74-13.21,13.79-22.57,26.57-23.73 c2.86-0.26,5.82-0.11,8.78,0.5c1.71,0.36,3.34,0.84,4.91,1.46c1.1,0.42,2.17,0.92,3.19,1.47 c11.36,6.1,17.87,19.13,15.12,32.41C172.13,376.21,161.07,385.56,148.3,386.73z M145.6,387.85c-2.11,0-4.21-0.22-6.28-0.65 c-8.08-1.67-15.03-6.39-19.57-13.29c-4.54-6.9-6.11-15.15-4.44-23.23c2.78-13.42,13.81-23.28,27.46-24.53 c3.03-0.28,6.09-0.1,9.07,0.52c1.75,0.36,3.46,0.87,5.08,1.51c1.1,0.42,2.22,0.94,3.3,1.52 c11.95,6.42,18.38,20.19,15.63,33.49c-2.78,13.42-13.81,23.27-27.45,24.52l0,0C147.46,387.81,146.53,387.85,145.6,387.85z  M145.55,328.03c-0.87,0-1.74,0.04-2.61,0.12c-12.76,1.17-23.08,10.38-25.68,22.94c-1.56,7.56-0.09,15.28,4.15,21.73 c4.24,6.45,10.74,10.87,18.3,12.43c2.79,0.58,5.65,0.75,8.48,0.49l0,0c12.76-1.16,23.08-10.38,25.68-22.93 c2.57-12.44-3.44-25.32-14.62-31.33c-1.01-0.54-2.04-1.02-3.08-1.42c-1.52-0.6-3.12-1.08-4.76-1.42 C149.49,328.23,147.52,328.03,145.55,328.03z"
  }))))), /*#__PURE__*/React.createElement("g", null, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 85.71,
    y: 376.61,
    className: "st166",
    width: 18.22,
    height: 55.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_164_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7149,
    y1: 404.3155,
    x2: 104.9297,
    y2: 404.3155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st168",
    d: "M103.93,433.02H85.71c-0.55,0-1-0.45-1-1v-55.41c0-0.55,0.45-1,1-1h18.21c0.55,0,1,0.45,1,1v55.41 C104.93,432.57,104.48,433.02,103.93,433.02z M86.71,431.02h16.21v-53.41H86.71V431.02z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "74.8,387.25 93.02,387.25 103.93,376.61 85.71,376.61  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_165_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8031,
    y1: 381.9307,
    x2: 104.9301,
    y2: 381.9307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03BEF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#964AE2"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st169",
    d: "M93.02,388.25H74.8c-0.41,0-0.77-0.25-0.93-0.62c-0.15-0.38-0.06-0.81,0.23-1.09l10.91-10.64 c0.19-0.18,0.44-0.28,0.7-0.28h18.21c0.41,0,0.77,0.25,0.93,0.62c0.15,0.38,0.06,0.81-0.23,1.09l-10.91,10.64 C93.53,388.15,93.28,388.25,93.02,388.25z M77.26,386.25h15.35l8.86-8.64H86.12L77.26,386.25z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_166_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.9307,
    y1: 404.3155,
    x2: 194.7432,
    y2: 404.3155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02247D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03BEF2"
    }
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 103.93,
    y: 376.61,
    className: "st170",
    width: 90.81,
    height: 55.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_167_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.9297,
    y1: 404.3155,
    x2: 195.7432,
    y2: 404.3155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st171",
    d: "M195.74,433.02h-92.81v-57.41h92.81V433.02z M104.93,431.02h88.81v-53.41h-88.81V431.02z"
  }))), /*#__PURE__*/React.createElement("g", null, _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st166",
    points: "205.65,387.25 114.84,387.25 103.93,376.61 194.74,376.61  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_168_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.93,
    y1: 381.9307,
    x2: 206.6547,
    y2: 381.9307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st172",
    d: "M205.65,388.25h-90.81c-0.26,0-0.51-0.1-0.7-0.28l-10.91-10.64c-0.29-0.28-0.38-0.72-0.23-1.09 c0.15-0.38,0.52-0.62,0.93-0.62h90.81c0.26,0,0.51,0.1,0.7,0.28l10.91,10.64c0.29,0.28,0.38,0.72,0.23,1.09 C206.43,388,206.06,388.25,205.65,388.25z M115.25,386.25h87.95l-8.86-8.64h-87.95L115.25,386.25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1235.3849,
    y1: 425.1697,
    x2: 1243.8723,
    y2: 440.4816,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st173",
    d: "M529.64,371.78l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.49-6.58,2.46-9.07-0.07L529.64,371.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.9044,
    y1: 431.8914,
    x2: 1260.998,
    y2: 431.8914,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st174",
    d: "M558.18,399.02c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.01,1.98-0.8,3.84-2.21,5.23l-0.1,0.09C561.94,398.32,560.06,399.02,558.18,399.02z  M531.05,371.79l23.27,23.62c1.01,1.03,2.37,1.6,3.82,1.61c0.01,0,0.03,0,0.04,0c1.43,0,2.78-0.55,3.8-1.56l0.1-0.09 c1.03-1.01,1.6-2.37,1.61-3.81c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L531.05,371.79z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_171_",
    gradientUnits: "userSpaceOnUse",
    x1: 1235.3849,
    y1: 425.1697,
    x2: 1243.8723,
    y2: 440.4816,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st175",
    d: "M529.64,371.78l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.49-6.58,2.46-9.07-0.07L529.64,371.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_172_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.9044,
    y1: 431.8914,
    x2: 1260.998,
    y2: 431.8914,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st176",
    d: "M558.18,399.02c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.01,1.98-0.8,3.84-2.21,5.23l-0.1,0.09C561.94,398.32,560.06,399.02,558.18,399.02z  M531.05,371.79l23.27,23.62c1.01,1.03,2.37,1.6,3.82,1.61c0.01,0,0.03,0,0.04,0c1.43,0,2.78-0.55,3.8-1.56l0.1-0.09 c1.03-1.01,1.6-2.37,1.61-3.81c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L531.05,371.79z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M535.23,385.18l16.97-16.72l44.09,44.75c4.57,4.64,4.52,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L535.23,385.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_173_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.735,
    y1: 449.2551,
    x2: 1253.052,
    y2: 449.2551,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st177",
    d: "M587.72,434.44c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01L597,412.51c2.4,2.44,3.71,5.66,3.68,9.08c-0.03,3.42-1.38,6.62-3.81,9.02l-0.17,0.17 C594.2,433.22,590.96,434.44,587.72,434.44z M536.65,385.19l43.38,44.04c4.18,4.24,11.02,4.29,15.26,0.12l0.17-0.17 c2.05-2.02,3.2-4.72,3.22-7.61c0.02-2.88-1.08-5.6-3.1-7.66l-43.38-44.03L536.65,385.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.1456,
    y1: 472.8888,
    x2: 1199.5485,
    y2: 472.8888,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st178",
    d: "M587.74,429.81c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.34l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C591.89,428.98,589.86,429.81,587.74,429.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_175_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.4493,
    y1: 465.2312,
    x2: 1214.4464,
    y2: 465.2312,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st179",
    points: "577.45,422.84 568.86,414.12 570.28,412.72 578.87,421.44  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_176_",
    gradientUnits: "userSpaceOnUse",
    x1: 1215.5079,
    y1: 457.9275,
    x2: 1221.941,
    y2: 457.9275,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st180",
    points: "566.88,412.12 562.29,407.46 563.72,406.06 568.31,410.71  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_177_",
    gradientUnits: "userSpaceOnUse",
    x1: 1235.3849,
    y1: 425.1697,
    x2: 1243.8723,
    y2: 440.4816,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#022894"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st181",
    d: "M529.64,371.78l9.23-9.09l23.97,24.33c2.49,2.52,2.46,6.58-0.07,9.07l-0.09,0.09 c-2.52,2.49-6.58,2.46-9.07-0.07L529.64,371.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_178_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.9044,
    y1: 431.8914,
    x2: 1260.998,
    y2: 431.8914,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st182",
    d: "M558.18,399.02c-1.92,0-3.83-0.74-5.28-2.21l-24.67-25.05l10.65-10.49l24.67,25.04 c1.39,1.41,2.15,3.28,2.13,5.26c-0.01,1.98-0.8,3.84-2.21,5.23l-0.1,0.09C561.94,398.32,560.06,399.02,558.18,399.02z  M531.05,371.79l23.27,23.62c1.01,1.03,2.37,1.6,3.82,1.61c0.01,0,0.03,0,0.04,0c1.43,0,2.78-0.55,3.8-1.56l0.1-0.09 c1.03-1.01,1.6-2.37,1.61-3.81c0.01-1.45-0.54-2.81-1.56-3.84l-23.27-23.62L531.05,371.79z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M535.23,385.18l16.97-16.72l44.09,44.75c4.57,4.64,4.52,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L535.23,385.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_179_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.735,
    y1: 449.2551,
    x2: 1253.052,
    y2: 449.2551,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st183",
    d: "M587.72,434.44c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01L597,412.51c2.4,2.44,3.71,5.66,3.68,9.08c-0.03,3.42-1.38,6.62-3.81,9.02l-0.17,0.17 C594.2,433.22,590.96,434.44,587.72,434.44z M536.65,385.19l43.38,44.04c4.18,4.24,11.02,4.29,15.26,0.12l0.17-0.17 c2.05-2.02,3.2-4.72,3.22-7.61c0.02-2.88-1.08-5.6-3.1-7.66l-43.38-44.03L536.65,385.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_180_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.1456,
    y1: 472.8888,
    x2: 1199.5485,
    y2: 472.8888,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st184",
    d: "M587.74,429.81c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.34l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C591.89,428.98,589.86,429.81,587.74,429.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_181_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.4493,
    y1: 465.2312,
    x2: 1214.4464,
    y2: 465.2312,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st185",
    points: "577.45,422.84 568.86,414.12 570.28,412.72 578.87,421.44  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1215.5079,
    y1: 457.9275,
    x2: 1221.941,
    y2: 457.9275,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st186",
    points: "566.88,412.12 562.29,407.46 563.72,406.06 568.31,410.71  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M535.23,385.18l16.97-16.72l44.09,44.75c4.57,4.64,4.52,12.11-0.12,16.68l-0.17,0.17 c-4.64,4.57-12.11,4.51-16.68-0.13L535.23,385.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_183_",
    gradientUnits: "userSpaceOnUse",
    x1: 1181.735,
    y1: 449.2551,
    x2: 1253.052,
    y2: 449.2551,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st187",
    d: "M587.72,434.44c-3.31,0-6.62-1.27-9.12-3.81l-44.08-44.75c-0.39-0.39-0.38-1.03,0.01-1.41l16.97-16.72 c0.39-0.39,1.03-0.38,1.41,0.01L597,412.51c2.4,2.44,3.71,5.66,3.68,9.08c-0.03,3.42-1.38,6.62-3.81,9.02l-0.17,0.17 C594.2,433.22,590.96,434.44,587.72,434.44z M536.65,385.19l43.38,44.04c4.18,4.24,11.02,4.29,15.26,0.12l0.17-0.17 c2.05-2.02,3.2-4.72,3.22-7.61c0.02-2.88-1.08-5.6-3.1-7.66l-43.38-44.03L536.65,385.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_184_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.1456,
    y1: 472.8888,
    x2: 1199.5485,
    y2: 472.8888,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M587.74,429.81c-0.42,0-0.84-0.03-1.26-0.1c-1.74-0.27-3.32-1.07-4.57-2.34l1.43-1.4 c0.94,0.95,2.13,1.56,3.44,1.76c1.94,0.29,3.85-0.32,5.25-1.7l1.4,1.43C591.89,428.98,589.86,429.81,587.74,429.81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_185_",
    gradientUnits: "userSpaceOnUse",
    x1: 1203.4493,
    y1: 465.2312,
    x2: 1214.4464,
    y2: 465.2312,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st189",
    points: "577.45,422.84 568.86,414.12 570.28,412.72 578.87,421.44  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_186_",
    gradientUnits: "userSpaceOnUse",
    x1: 1215.5079,
    y1: 457.9275,
    x2: 1221.941,
    y2: 457.9275,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st190",
    points: "566.88,412.12 562.29,407.46 563.72,406.06 568.31,410.71  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_187_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.9974,
    y1: 392.3105,
    x2: 1345.9603,
    y2: 392.3105,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st191",
    d: "M448.84,332.33c-0.14,14.58,5.95,27.98,15.85,37.52c8.17,7.89,18.94,13.13,30.92,14.22 c1.38,0.12,2.81,0.18,4.18,0.19c7.06,0.08,13.89-1.25,20.34-3.92c1.05-0.44,2.08-0.92,3.08-1.43c2.84-1.43,5.54-3.11,8.09-5.04 c1.78-1.37,3.49-2.84,5.09-4.41c1.55-1.53,3.01-3.15,4.32-4.84c7.12-8.96,10.93-19.8,11.04-31.31 c0.12-13.75-5.11-26.71-14.76-36.54c-8.58-8.72-19.96-14.12-32.03-15.21c-1.39-0.11-2.8-0.21-4.22-0.21 c-13.74-0.12-26.77,5.17-36.58,14.83C454.39,305.79,448.93,318.64,448.84,332.33z M470.41,302.48 c8.15-8.03,18.9-12.38,30.27-12.29c1.16,0.03,2.35,0.08,3.49,0.17c10.01,0.91,19.41,5.39,26.49,12.62 c8,8.11,12.35,18.84,12.22,30.2c-0.11,11.3-4.61,21.92-12.7,29.92l-0.76,0.72c-1.42,1.31-2.91,2.52-4.45,3.61 c-7.4,5.26-16.08,8.01-25.1,7.94c-1.15-0.03-2.3-0.06-3.45-0.19c-12.25-1.11-22.96-7.46-30-16.7 c-5.54-7.29-8.8-16.37-8.71-26.09C457.84,321.07,462.34,310.45,470.41,302.48z M500.2,376.39c-0.11,0-0.22,0-0.33,0 c-1.2-0.03-2.36-0.06-3.55-0.19c-12.06-1.09-23.25-7.32-30.68-17.09c-5.92-7.79-9.01-17.03-8.92-26.7 c0.13-11.61,4.74-22.49,12.99-30.63l0,0c8.34-8.21,19.32-12.68,30.98-12.57c1.41,0.03,2.54,0.09,3.57,0.18 c10.23,0.93,19.86,5.51,27.12,12.92c8.19,8.3,12.63,19.28,12.51,30.92c-0.11,11.57-4.73,22.44-13,30.62l-0.77,0.73 c-1.47,1.35-3,2.59-4.56,3.7C518.06,373.58,509.3,376.39,500.2,376.39z M471.11,303.2c-7.87,7.77-12.28,18.15-12.4,29.23 c-0.08,9.23,2.86,18.03,8.51,25.47c7.09,9.32,17.77,15.27,29.29,16.31c1.13,0.13,2.24,0.16,3.38,0.18c0.1,0,0.21,0,0.31,0 c8.68,0,17.04-2.68,24.18-7.76c1.49-1.06,2.95-2.24,4.35-3.53l0.75-0.71c7.88-7.79,12.29-18.17,12.39-29.2 c0.12-11.1-4.12-21.57-11.93-29.49c-6.93-7.07-16.11-11.44-25.87-12.33c-0.99-0.09-2.07-0.14-3.42-0.17c-0.12,0-0.25,0-0.37,0 C489.33,291.2,478.98,295.45,471.11,303.2L471.11,303.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_188_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.9974,
    y1: 392.3105,
    x2: 1345.9603,
    y2: 392.3105,
    gradientTransform: "matrix(-0.9886 -0.1507 -0.1507 0.9886 1839.1415 140.0416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st192",
    d: "M448.84,332.33c-0.14,14.58,5.95,27.98,15.85,37.52c8.17,7.89,18.94,13.13,30.92,14.22 c1.38,0.12,2.81,0.18,4.18,0.19c7.06,0.08,13.89-1.25,20.34-3.92c1.05-0.44,2.08-0.92,3.08-1.43c2.84-1.43,5.54-3.11,8.09-5.04 c1.78-1.37,3.49-2.84,5.09-4.41c1.55-1.53,3.01-3.15,4.32-4.84c7.12-8.96,10.93-19.8,11.04-31.31 c0.12-13.75-5.11-26.71-14.76-36.54c-8.58-8.72-19.96-14.12-32.03-15.21c-1.39-0.11-2.8-0.21-4.22-0.21 c-13.74-0.12-26.77,5.17-36.58,14.83C454.39,305.79,448.93,318.64,448.84,332.33z M470.41,302.48 c8.15-8.03,18.9-12.38,30.27-12.29c1.16,0.03,2.35,0.08,3.49,0.17c10.01,0.91,19.41,5.39,26.49,12.62 c8,8.11,12.35,18.84,12.22,30.2c-0.11,11.3-4.61,21.92-12.7,29.92l-0.76,0.72c-1.42,1.31-2.91,2.52-4.45,3.61 c-7.4,5.26-16.08,8.01-25.1,7.94c-1.15-0.03-2.3-0.06-3.45-0.19c-12.25-1.11-22.96-7.46-30-16.7 c-5.54-7.29-8.8-16.37-8.71-26.09C457.84,321.07,462.34,310.45,470.41,302.48z M500.2,376.39c-0.11,0-0.22,0-0.33,0 c-1.2-0.03-2.36-0.06-3.55-0.19c-12.06-1.09-23.25-7.32-30.68-17.09c-5.92-7.79-9.01-17.03-8.92-26.7 c0.13-11.61,4.74-22.49,12.99-30.63l0,0c8.34-8.21,19.32-12.68,30.98-12.57c1.41,0.03,2.54,0.09,3.57,0.18 c10.23,0.93,19.86,5.51,27.12,12.92c8.19,8.3,12.63,19.28,12.51,30.92c-0.11,11.57-4.73,22.44-13,30.62l-0.77,0.73 c-1.47,1.35-3,2.59-4.56,3.7C518.06,373.58,509.3,376.39,500.2,376.39z M471.11,303.2c-7.87,7.77-12.28,18.15-12.4,29.23 c-0.08,9.23,2.86,18.03,8.51,25.47c7.09,9.32,17.77,15.27,29.29,16.31c1.13,0.13,2.24,0.16,3.38,0.18c0.1,0,0.21,0,0.31,0 c8.68,0,17.04-2.68,24.18-7.76c1.49-1.06,2.95-2.24,4.35-3.53l0.75-0.71c7.88-7.79,12.29-18.17,12.39-29.2 c0.12-11.1-4.12-21.57-11.93-29.49c-6.93-7.07-16.11-11.44-25.87-12.33c-0.99-0.09-2.07-0.14-3.42-0.17c-0.12,0-0.25,0-0.37,0 C489.33,291.2,478.98,295.45,471.11,303.2L471.11,303.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M521.91,311.49H478.7c-3.03,0-5.48,2.45-5.48,5.48v24.09c0,3.03,2.45,5.48,5.48,5.48h23.2v13.5 l13.24-13.5h6.78c3.03,0,5.48-2.45,5.48-5.48v-24.09C527.39,313.94,524.94,311.49,521.91,311.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_189_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.2188,
    y1: 335.7632,
    x2: 528.3897,
    y2: 335.7632
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F41DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03F3F8"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st193",
    d: "M501.9,361.04c-0.13,0-0.26-0.02-0.38-0.07c-0.38-0.15-0.62-0.52-0.62-0.93v-12.5h-22.2 c-3.57,0-6.48-2.91-6.48-6.48v-24.09c0-3.57,2.91-6.48,6.48-6.48h43.21c3.57,0,6.48,2.91,6.48,6.48v24.09 c0,3.57-2.91,6.48-6.48,6.48h-6.36l-12.94,13.2C502.42,360.94,502.16,361.04,501.9,361.04z M478.7,312.49 c-2.47,0-4.48,2.01-4.48,4.48v24.09c0,2.47,2.01,4.48,4.48,4.48h23.2c0.55,0,1,0.45,1,1v11.05l11.52-11.75 c0.19-0.19,0.45-0.3,0.71-0.3h6.78c2.47,0,4.48-2.01,4.48-4.48v-24.09c0-2.47-2.01-4.48-4.48-4.48H478.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M489.6,335.29l-6.26-6.26c-0.36-0.36-0.36-0.94,0-1.3l6.09-6.09l1.3,1.3l-5.44,5.44l5.62,5.62 L489.6,335.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_190_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.0718,
    y1: 328.4604,
    x2: 491.9014,
    y2: 328.4604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st194",
    d: "M489.6,336.29c-0.26,0-0.51-0.1-0.71-0.29l-6.26-6.26c-0.75-0.75-0.75-1.96,0-2.71l6.09-6.09 c0.39-0.39,1.02-0.39,1.41,0l1.3,1.3c0.39,0.39,0.39,1.02,0,1.41l-4.73,4.73l4.91,4.91c0.19,0.19,0.29,0.44,0.29,0.71 c0,0.27-0.11,0.52-0.29,0.71l-1.3,1.3C490.11,336.19,489.86,336.29,489.6,336.29z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M511.71,335.59l-1.3-1.3l5.75-5.75l-5.75-5.75l1.3-1.3l6.4,6.4c0.17,0.17,0.27,0.41,0.27,0.65 c0,0.24-0.1,0.48-0.27,0.65L511.71,335.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_191_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.4151,
    y1: 328.5474,
    x2: 519.3799,
    y2: 328.5474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st195",
    d: "M511.71,336.59L511.71,336.59c-0.27,0-0.52-0.11-0.71-0.29l-1.3-1.3c-0.39-0.39-0.39-1.02,0-1.41 l5.04-5.04l-5.04-5.04c-0.19-0.19-0.29-0.44-0.29-0.71c0-0.27,0.11-0.52,0.29-0.71l1.3-1.3c0.39-0.39,1.02-0.39,1.41,0 l6.4,6.4c0.36,0.36,0.56,0.85,0.56,1.36c0,0.51-0.2,0.99-0.56,1.36l-6.4,6.4C512.23,336.49,511.98,336.59,511.71,336.59z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 488.95,
    y: 327.54,
    transform: "matrix(0.4065 -0.9136 0.9136 0.4065 -2.6896 652.7808)",
    className: "st134",
    width: 24.36,
    height: 1.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_192_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.3409,
    y1: 328.4608,
    x2: 507.912,
    y2: 328.4608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC20B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F24B89"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st196",
    d: "M497.02,340.96c-0.14,0-0.27-0.03-0.41-0.09l-1.68-0.75c-0.24-0.11-0.43-0.31-0.53-0.55 c-0.09-0.25-0.09-0.52,0.02-0.77l9.89-22.26c0.22-0.5,0.82-0.73,1.32-0.51l1.68,0.75c0.24,0.11,0.43,0.31,0.53,0.55 c0.09,0.25,0.09,0.52-0.02,0.77l-9.89,22.26C497.77,340.74,497.4,340.96,497.02,340.96z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1590_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1591_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_193_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.2735,
    y1: 200.4551,
    x2: 269.9414,
    y2: 200.4551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 154.27,
    y: 185.92,
    className: "st197",
    width: 115.67,
    height: 29.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_194_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.2735,
    y1: 200.4546,
    x2: 270.9414,
    y2: 200.4546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#03F3F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F41DB"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st198",
    d: "M270.94,215.99H153.27v-31.06h117.67V215.99z M155.27,213.99h113.67v-27.06H155.27V213.99z"
  })))))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M171.09,193.51h1.59v8.23c0,3.27-1.61,4.27-3.72,4.27c-0.58,0-1.3-0.13-1.7-0.29l0.24-1.3 c0.33,0.13,0.8,0.24,1.33,0.24c1.42,0,2.26-0.64,2.26-3.05V193.51z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M177.32,201.94l-1.28,3.87h-1.64l4.18-12.3h1.92l4.2,12.3h-1.7l-1.31-3.87H177.32z M181.35,200.7 l-1.21-3.54c-0.27-0.8-0.46-1.53-0.64-2.25h-0.04c-0.18,0.73-0.38,1.48-0.62,2.23l-1.2,3.56H181.35z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M188.23,205.81l-4.01-12.3h1.71l1.92,6.06c0.53,1.66,0.98,3.16,1.31,4.6h0.04 c0.35-1.42,0.86-2.97,1.41-4.58l2.08-6.08h1.7l-4.4,12.3H188.23z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M196.67,201.94l-1.28,3.87h-1.64l4.18-12.3h1.92l4.2,12.3h-1.7l-1.31-3.87H196.67z M200.7,200.7 l-1.2-3.54c-0.27-0.8-0.46-1.53-0.64-2.25h-0.04c-0.18,0.73-0.38,1.48-0.62,2.23l-1.2,3.56H200.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M205.63,203.88c0.71,0.44,1.75,0.8,2.85,0.8c1.62,0,2.57-0.86,2.57-2.1c0-1.15-0.66-1.81-2.32-2.45 c-2.01-0.71-3.25-1.75-3.25-3.49c0-1.92,1.59-3.34,3.98-3.34c1.26,0,2.17,0.29,2.72,0.6l-0.44,1.3 c-0.4-0.22-1.22-0.58-2.34-0.58c-1.68,0-2.32,1-2.32,1.84c0,1.15,0.75,1.72,2.45,2.37c2.08,0.8,3.14,1.81,3.14,3.62 c0,1.9-1.41,3.54-4.31,3.54c-1.19,0-2.48-0.35-3.14-0.78L205.63,203.88z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M223.44,205.41c-0.58,0.29-1.75,0.58-3.25,0.58c-3.47,0-6.08-2.19-6.08-6.22 c0-3.85,2.61-6.46,6.42-6.46c1.53,0,2.5,0.33,2.92,0.55l-0.38,1.3c-0.6-0.29-1.46-0.51-2.48-0.51c-2.88,0-4.8,1.84-4.8,5.07 c0,3.01,1.73,4.95,4.73,4.95c0.97,0,1.95-0.2,2.59-0.51L223.44,205.41z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M225.43,193.67c0.8-0.16,1.95-0.26,3.05-0.26c1.7,0,2.79,0.31,3.56,1c0.62,0.55,0.97,1.39,0.97,2.34 c0,1.62-1.02,2.7-2.32,3.14v0.05c0.95,0.33,1.51,1.21,1.81,2.48c0.4,1.72,0.69,2.9,0.95,3.38h-1.64 c-0.2-0.35-0.47-1.41-0.82-2.94c-0.37-1.7-1.02-2.34-2.46-2.39h-1.5v5.33h-1.59V193.67z M227.02,199.28h1.62 c1.7,0,2.77-0.93,2.77-2.34c0-1.59-1.15-2.28-2.83-2.3c-0.77,0-1.31,0.07-1.57,0.15V199.28z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M236.84,193.51v12.3h-1.59v-12.3H236.84z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M239.61,193.66c0.77-0.13,1.77-0.24,3.05-0.24c1.57,0,2.72,0.37,3.45,1.02 c0.67,0.58,1.08,1.48,1.08,2.57c0,1.11-0.33,1.99-0.95,2.63c-0.84,0.89-2.21,1.35-3.76,1.35c-0.47,0-0.91-0.02-1.28-0.11 v4.93h-1.59V193.66z M241.2,199.59c0.35,0.09,0.79,0.13,1.31,0.13c1.92,0,3.08-0.93,3.08-2.63c0-1.62-1.15-2.41-2.9-2.41 c-0.69,0-1.22,0.05-1.5,0.13V199.59z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M251.66,194.86h-3.74v-1.35h9.11v1.35h-3.76v10.95h-1.61V194.86z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_195_",
    gradientUnits: "userSpaceOnUse",
    x1: 3498.4561,
    y1: 417.2509,
    x2: 3511.3135,
    y2: 417.2509,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st199",
    d: "M259.17,414.87c3.55-0.18,5.33-4.12,5.77-4.16c0.11-0.01,0.24-0.11,0.41,0.27 c0.48,1.08-0.66,3.27-1.16,3.74c1.38,0.65,1.79,0.88,3.39,1.45c2.44,0.86,4.25,1.55,2.96,4.82c-0.72,1.83-3.14,2.49-3.29,2.66 c-0.13,0.15-0.72,0.14-0.93,0.14c-0.73,0.02-1.54-0.03-3.14-1.44c-0.55-0.49-3.53-2.15-5.08-2.75L259.17,414.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M224.19,397.22c1.48,4.93,4.35,8.35,9.8,17.07c1.97,3.16,15.68,3.59,25.22,5.71l0.93-5.2l-19.89-4.93 c0,0-8.29-17.27-13.33-18.55C224.67,390.74,222.48,391.54,224.19,397.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_196_",
    gradientUnits: "userSpaceOnUse",
    x1: 3508.2937,
    y1: 405.5783,
    x2: 3546.8562,
    y2: 405.5783,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st200",
    d: "M258.99,420.98c-3.21-0.71-6.92-1.23-10.5-1.73c-8.56-1.2-13.88-2.06-15.35-4.42 c-1.47-2.35-2.74-4.3-3.87-6.03c-3.07-4.71-4.92-7.55-6.05-11.29l0,0c-0.95-3.17-0.86-5.28,0.27-6.46 c0.58-0.6,1.68-1.21,3.67-0.7c5.04,1.29,12.26,15.56,13.78,18.67l19.43,4.82c0.51,0.13,0.84,0.63,0.74,1.15l-0.93,5.2 c-0.05,0.27-0.2,0.51-0.43,0.66c-0.17,0.11-0.36,0.17-0.55,0.17C259.14,421,259.07,420.99,258.99,420.98z M240.01,410.84 c-0.29-0.07-0.53-0.27-0.66-0.54c-3.13-6.52-9.34-17.17-12.68-18.02c-0.48-0.12-1.34-0.26-1.73,0.15 c-0.21,0.21-0.8,1.17,0.2,4.5c1.04,3.46,2.83,6.21,5.81,10.77c1.13,1.73,2.41,3.7,3.89,6.06c1.05,1.69,7.9,2.65,13.94,3.5 c3.25,0.46,6.6,0.93,9.63,1.55l0.58-3.26L240.01,410.84z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_197_",
    gradientUnits: "userSpaceOnUse",
    x1: 3546.9404,
    y1: 466.0763,
    x2: 3570.8413,
    y2: 466.0763,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M199.72,482.73c0.04-0.03,0.12-0.05,0.17-0.08c2.07-3.25,0.83-12.86,4.56-18.65 c4.33-6.71,3.79-14.97,3.79-21.39l14.23-5.27c0,7.32-7.82,22.17-11.08,30.22c-4.19,10.35-7.29,14.02-6.38,19.1 c1.26,2.54,3.12,5.71,5.45,7.03c0.38,0.22-0.41,1.59-2.88,0.98c-4.53-1.1-3.16-5.51-7.11-7.62 C197.67,485.55,198.5,483.64,199.72,482.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_198_",
    gradientUnits: "userSpaceOnUse",
    x1: 3516.1716,
    y1: 450.0794,
    x2: 3543.6113,
    y2: 450.0794,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st202",
    d: "M237.48,425.22c4.8,2.44,15.42,12.98,15.66,13.83c0.24,0.85,0.12,1.76-0.33,2.51 c0,0-16.86,20.42-17.75,24.22c0.89,2.86,1.68,7.15,3.1,8.71c0.3,0.33-0.88,1.38-3.05,0.05c-3.97-2.44-1.75-4.79-4.26-8.5 c-2.92-4.32-0.3-4.31,1.3-4.69c3.44-3.41,4.85-15.68,10.02-20.5c0,0-12.38-4.38-15.94-8.21 C223.63,429.87,234.28,423.59,237.48,425.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M208.96,356.84c5.73-1.23,8.76,1.88,8.76,1.88c17.46-2.68,20.74,22.25,12.79,28.46 c-6.44,5.04-11.82,1.56-11.82,1.56s-3.64,2.71-9.2,3.57c-3.45,0.53-7.61-1.73-7.61-1.73s-4.87,3.48-8.6-1.67 c-3.73-5.15,1.79-10.61,4.72-10.66c0,0-3.51-4.23,1.3-7.04C201.19,370.1,198.01,359.19,208.96,356.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_199_",
    gradientUnits: "userSpaceOnUse",
    x1: 3533.8118,
    y1: 374.4731,
    x2: 3578.4175,
    y2: 374.4731,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st203",
    d: "M201.93,391.73c-2.18,1.26-6.33,2.1-9.47-2.23c-1.68-2.32-1.9-5.01-0.62-7.57 c0.99-1.99,2.81-3.66,4.57-4.35c-0.43-0.88-0.82-2.11-0.58-3.45c0.27-1.53,1.27-2.8,2.9-3.74c0.19-0.25,0.32-1.42,0.41-2.28 c0.39-3.65,1.13-10.43,9.61-12.25c5.06-1.08,8.22,0.94,9.29,1.8c7.03-0.9,12.75,2.47,15.71,9.31 c3.32,7.68,2.12,17.29-2.62,20.99c-5.73,4.48-10.69,2.76-12.38,1.95c-1.24,0.8-4.54,2.69-9.11,3.39 c-0.41,0.06-0.83,0.09-1.25,0.09C205.73,393.4,203.05,392.26,201.93,391.73z M219.22,387.91c0.05,0.03,4.85,3.03,10.66-1.51 c4.01-3.13,4.95-11.84,2.02-18.62c-1.55-3.58-5.43-9.38-14.04-8.06l-0.51,0.08l-0.36-0.37c-0.03-0.03-2.72-2.7-7.84-1.6 c-7.07,1.52-7.63,6.72-8.04,10.51c-0.2,1.84-0.34,3.17-1.33,3.74c-1.16,0.68-1.83,1.48-2,2.4c-0.29,1.58,0.95,3.12,0.96,3.13 l1.33,1.6l-2.08,0.04c-1.24,0.02-3.35,1.5-4.39,3.58c-0.66,1.32-1.11,3.34,0.46,5.5c3.04,4.19,6.8,1.73,7.21,1.44l0.51-0.36 l0.55,0.3c0.04,0.02,3.9,2.09,6.98,1.62c5.23-0.8,8.72-3.36,8.76-3.38l0.56-0.41L219.22,387.91z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_200_",
    gradientUnits: "userSpaceOnUse",
    x1: 3537.8442,
    y1: 376.7566,
    x2: 3560.2756,
    y2: 380.7118,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st204",
    d: "M208.34,367.78c0.91-2.52,2.74-4.71,5.32-6c1.71-0.86,3.53-1.22,5.31-1.15c3.8,0.16,7.4,2.32,9.24,5.96 l1.91,3.81c1.76,3.5,0.55,7.45-0.67,10.89c-1.12,3.17-3.82,4.3-6.58,4.46l0.04,1.79l0.04,2.16c1.79,0.31,3.41,1.14,4.54,2.44 c1.41,1.63,0.45,3.41-0.72,4.01c-3.18,1.22-9.79-1.36-10.77-4.37c0.27-0.32,0.58-0.6,0.9-0.86c-0.01-0.05-0.02-0.1,0.01-0.15 c0.59-1.36,0.4-4.4,0.27-5.84c-0.45-0.16-0.85-0.32-1.18-0.48c-2.04-1.01-4.13-2.11-5.23-4.29l-1.92-3.8 C207.46,373.56,207.36,370.48,208.34,367.78z"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M213.35,373.72c7.77,1.26,8.63-7.12,8.19-10.56c-0.93-7.21-10.34-5.82-13.64-2.23 c-2.04,2.22-5.67,8.24-4.1,15.72c1.56,7.48,9.2,12.13,9.2,12.13c8.39-6.15-0.28-12.04-0.28-12.04L213.35,373.72z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st205",
    d: "M222.35,379.91c0.91,1.19,2.55,1.61,3.94,0.91c1.38-0.7,2.03-2.27,1.62-3.71L222.35,379.91z"
  }))), /*#__PURE__*/React.createElement("g", null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M212.08,418.36c3.91-5.45,2.5-12.77,2.4-22.76c-0.01-1.47,0.63-2.79,1.51-3.84 c2.48-0.27,6.87,1.75,9.45,1.86c1.18,0.06,1.98-0.28,2.03-1.43c0.01-0.01,0.01-0.04,0.01-0.07c0.09,0.09,0.18,0.21,0.27,0.32 c0.01,0.01,0.01,0.01,0.02,0.02c0.04,0.06,0.08,0.1,0.13,0.16c1.52,1.82,4.95,3.63,5.73,5.47c0.82,1.93-0.93,3.85-3.13,4.47 c-0.66,5.57-3.17,12.18,1.5,15.52c4.39,3.12,8.18,7.96,8.18,7.96c-13.12,14.81-32.83,18.86-32.83,18.86 C208.76,439.66,204.88,428.37,212.08,418.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_201_",
    gradientUnits: "userSpaceOnUse",
    x1: 3528.2607,
    y1: 418.3215,
    x2: 3563.0925,
    y2: 418.3215,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st206",
    d: "M206.61,445.59c-0.24-0.25-0.33-0.61-0.24-0.95c0.41-1.51,0.33-3.71,0.24-6.25 c-0.2-5.69-0.47-13.49,4.65-20.62l0,0c2.88-4.01,2.66-9.35,2.39-16.11c-0.08-1.92-0.16-3.91-0.18-6.06 c-0.02-1.97,0.94-3.53,1.74-4.49c0.17-0.2,0.4-0.32,0.66-0.35c1.58-0.17,3.65,0.42,5.65,0.98c1.44,0.41,2.92,0.83,3.96,0.87 c0.96,0.04,0.97-0.17,0.98-0.47c0-0.06,0.01-0.13,0.03-0.19c0.06-0.33,0.28-0.62,0.6-0.76c0.37-0.15,0.8-0.07,1.09,0.22 c0.11,0.11,0.22,0.25,0.35,0.42c0.02,0.03,0.04,0.05,0.05,0.06l0.07,0.09c0.57,0.67,1.5,1.41,2.41,2.12 c1.5,1.18,2.92,2.29,3.47,3.61c0.41,0.97,0.38,1.99-0.09,2.96c-0.55,1.15-1.67,2.11-3.06,2.65c-0.13,0.96-0.31,1.93-0.48,2.88 c-0.81,4.51-1.57,8.77,1.64,11.07c4.46,3.17,8.23,7.95,8.39,8.16c0.3,0.38,0.28,0.92-0.04,1.28 c-13.19,14.89-32.56,19.01-33.38,19.18c-0.07,0.01-0.13,0.02-0.2,0.02C207.07,445.91,206.8,445.8,206.61,445.59z M231.41,418.9 c-4.24-3.04-3.29-8.36-2.45-13.05c0.21-1.19,0.41-2.31,0.54-3.4c0.05-0.4,0.33-0.73,0.72-0.84c1.1-0.31,2.06-1.02,2.44-1.81 c0.22-0.45,0.23-0.88,0.05-1.32c-0.35-0.84-1.69-1.89-2.87-2.81c-0.71-0.56-1.44-1.13-2.07-1.74c-0.45,0.43-1.18,0.75-2.37,0.69 c-1.26-0.05-2.79-0.49-4.41-0.95c-1.63-0.46-3.31-0.94-4.49-0.94c-0.52,0.7-1.03,1.69-1.01,2.85c0.02,2.11,0.1,4.09,0.18,6 c0.29,7.14,0.51,12.79-2.76,17.35l0,0c-4.72,6.58-4.48,13.68-4.28,19.38c0.07,1.97,0.13,3.74-0.03,5.25 c4.67-1.24,19.59-5.93,30.26-17.56C237.68,424.61,234.69,421.24,231.41,418.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M199.31,482c1.52,1.15,4.52,8.83,5.92,11.01c1.15,1.86,4.51,1.05,4.22-0.62 c1.48,1.97,4.45,2.66,4.18,4.55c-0.21,1.43-4.41,1.38-5.68,1.28c-2.77-0.15-3.52-2.44-4.12-5.08c-0.68-3.01-2.42-4.73-3.41-5.64 c0.14,1.81-0.06,6.26,0.04,7.67h-0.48c-0.16-2.73-0.5-5.29-1.4-8.02C197.95,485.22,198.18,483.52,199.31,482z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_202_",
    gradientUnits: "userSpaceOnUse",
    x1: 3554.7781,
    y1: 490.1449,
    x2: 3572.1921,
    y2: 490.1449,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st207",
    d: "M207.9,499.23c-3.76-0.21-4.56-3.74-5.04-5.85c-0.3-1.32-0.83-2.38-1.39-3.19c0,0.52-0.01,1.06-0.02,1.6 c-0.02,1.33-0.04,2.71,0.01,3.32c0.02,0.28-0.07,0.55-0.26,0.76c-0.19,0.2-0.46,0.32-0.73,0.32h-0.48c-0.53,0-0.97-0.41-1-0.94 c-0.19-3.14-0.59-5.46-1.35-7.76c-0.75-2.26-0.46-4.31,0.87-6.08c0.16-0.21,0.4-0.35,0.66-0.39c0.26-0.04,0.53,0.03,0.74,0.19 c1.06,0.8,2.31,3.35,4.09,7.15c0.81,1.72,1.57,3.35,2.08,4.14c0.41,0.67,1.37,0.68,1.92,0.47c0.24-0.09,0.49-0.26,0.46-0.4 c-0.08-0.45,0.16-0.91,0.59-1.09c0.42-0.18,0.92-0.05,1.2,0.32c0.5,0.66,1.25,1.19,1.97,1.7c1.24,0.87,2.65,1.86,2.4,3.6 c-0.27,1.84-3.07,2.2-5.19,2.2C208.85,499.28,208.31,499.26,207.9,499.23z M211.08,495.12c-0.42-0.29-0.86-0.6-1.29-0.96 c-0.28,0.28-0.64,0.51-1.07,0.67c-1.09,0.42-2.49,0.35-3.52-0.39c0.55,1.81,1.27,2.71,2.83,2.79c1.98,0.14,4.17-0.1,4.62-0.5 C212.66,496.29,212.14,495.87,211.08,495.12z M201,486.69c-0.53-1.09-1.08-2.15-1.54-2.9c-0.33,0.92-0.3,1.92,0.08,3.06 c0.01,0.04,0.03,0.08,0.04,0.12c0.1-0.15,0.24-0.28,0.41-0.37c0.14-0.07,0.29-0.1,0.44-0.1 C200.63,486.51,200.83,486.58,201,486.69z"
  }))), /*#__PURE__*/React.createElement("g", null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M230.13,462.39c1.3,1.46,2.65,9.46,3.6,11.86c0.76,2.04,4.38,2.08,4.46,0.43 c1.08,2.23,3.96,3.6,3.26,5.32c-0.53,1.31-4.82,0.24-6.1-0.16c-2.8-0.81-3.06-3.16-3.08-5.8c-0.02-3.02-1.42-5.07-2.23-6.16 c-0.26,1.75-1.46,5.91-1.67,7.28l-0.49-0.12c0.44-2.63,0.67-5.13,0.36-7.93C228.02,465.11,228.64,463.55,230.13,462.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_203_",
    gradientUnits: "userSpaceOnUse",
    x1: 3526.873,
    y1: 471.5123,
    x2: 3542.5493,
    y2: 471.5123,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st208",
    d: "M235.07,480.8c-3.76-1.09-3.78-4.64-3.8-6.75c-0.01-1.4-0.36-2.57-0.78-3.5 c-0.13,0.53-0.27,1.08-0.4,1.62c-0.31,1.25-0.64,2.54-0.73,3.13c-0.04,0.28-0.2,0.52-0.43,0.68c-0.23,0.16-0.52,0.21-0.79,0.14 l-0.49-0.12c-0.51-0.12-0.84-0.62-0.76-1.14c0.51-3.01,0.62-5.3,0.35-7.65c-0.26-2.35,0.5-4.25,2.27-5.62 c0.41-0.32,1.01-0.27,1.36,0.12c0.9,1.01,1.61,3.73,2.59,7.76c0.44,1.82,0.86,3.55,1.2,4.42c0.23,0.62,0.98,0.9,1.54,0.95 c0.58,0.04,0.93-0.13,0.97-0.21c0.02-0.46,0.35-0.84,0.8-0.94c0.45-0.09,0.9,0.13,1.1,0.54c0.36,0.75,1.01,1.43,1.64,2.08 c1.08,1.13,2.31,2.42,1.64,4.05c-0.38,0.95-1.48,1.26-2.74,1.26C238.02,481.63,236.13,481.13,235.07,480.8z M239.28,477.71 c-0.38-0.39-0.78-0.81-1.15-1.28c-0.31,0.18-0.68,0.31-1.11,0.38c-1.25,0.19-2.8-0.21-3.69-1.28c0.16,1.86,0.71,2.89,2.31,3.36 c2,0.62,4.31,0.92,4.9,0.65C240.61,479.14,240.08,478.54,239.28,477.71z M229.24,467c0.01,0.09,0.02,0.17,0.03,0.26 c0.13-0.17,0.32-0.29,0.54-0.35c0.39-0.1,0.81,0.05,1.05,0.38c0,0.01,0.01,0.01,0.02,0.02c-0.32-1.23-0.66-2.43-0.97-3.26 C229.31,464.85,229.11,465.81,229.24,467z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_204_",
    gradientUnits: "userSpaceOnUse",
    x1: 3546.803,
    y1: 373.2854,
    x2: 3562.2754,
    y2: 373.2854,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st209",
    d: "M213.58,389.58c2.74-2.01,4.11-4.25,4.07-6.65c-0.06-3.21-2.66-5.67-3.83-6.61l0.32-1.5 c2.3,0.18,4.19-0.45,5.65-1.86c2.82-2.73,3.05-7.53,2.74-9.93c-0.36-2.83-1.98-4.83-4.54-5.65c-3.5-1.11-8.36,0.17-10.83,2.86 l1.47,1.35c1.71-1.87,5.73-3.27,8.75-2.31c1.83,0.58,2.9,1.93,3.16,4c0.28,2.2-0.05,6.22-2.15,8.24 c-1.17,1.14-2.82,1.54-4.89,1.21l-0.94-0.15l-0.98,4.6l0.55,0.38c0.03,0.02,3.45,2.4,3.5,5.41c0.03,1.71-1.07,3.4-3.25,5 L213.58,389.58z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_205_",
    gradientUnits: "userSpaceOnUse",
    x1: -1119.16,
    y1: 1190.4274,
    x2: -1107.5071,
    y2: 1190.4274,
    gradientTransform: "matrix(0.0141 0.9999 0.9999 -0.0141 -920.1616 1548.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2395,
    style: {
      stopColor: "#FA9A35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    style: {
      stopColor: "#F67160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6939,
    style: {
      stopColor: "#F35480"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8749,
    style: {
      stopColor: "#F14193"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st210",
    d: "M250.03,416.25c3.18-0.26,4.68-3.86,5.07-3.9c0.1-0.01,0.21-0.1,0.38,0.23c0.46,0.96-0.5,2.96-0.94,3.4 c1.25,0.55,3.33,0.41,4.82,1.77c0.8,0.73,0.04,1.84-0.11,2.03c-1.09,1.39-2.99,3.72-3.22,4c-0.12,0.14-0.31,0.19-0.5,0.2 c-0.66,0.04-1.38,0.02-2.86-1.21c-0.51-0.42-2.05-1.73-3.45-2.23L250.03,416.25z"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M225.88,414.77c-4.25-7.19-10.89-10.58-10.97-16.4c0.88-0.12,1.71-0.51,2.27-1.24 c0.93-1.23,3.46-0.51,4.46-1.65c2.32,5.58,10.4,15.17,10.4,15.17l19.09,5.25l-1.02,5C240.94,418.63,227.71,417.88,225.88,414.77 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M232.5,410.4c0,0-7.46-8.85-10.1-14.49l-7.03,2.21c0.08,5.82,6.72,9.21,10.97,16.4 c1.83,3.1,15.06,3.86,24.23,6.13l1.02-5L232.5,410.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_206_",
    gradientUnits: "userSpaceOnUse",
    x1: -1136.4653,
    y1: 1169.7167,
    x2: -1109.6819,
    y2: 1169.7167,
    gradientTransform: "matrix(0.0141 0.9999 0.9999 -0.0141 -920.1616 1548.1836)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st211",
    d: "M252.77,414.94l-19.7-5.42c-1.19-1.44-7.45-9.08-9.76-14.04l-1.81,0.85c2.67,5.7,9.93,14.35,10.24,14.71 l0.2,0.24l18.49,5.09l-0.63,3.07c-2.91-0.67-6.12-1.2-9.24-1.72c-5.81-0.97-12.39-2.06-13.36-3.71 c-1.76-2.98-3.91-5.32-5.81-7.39c-2.78-3.02-4.97-5.41-5.02-8.51l-2,0.03c0.05,3.87,2.6,6.63,5.54,9.84 c1.83,2,3.91,4.26,5.57,7.06c1.37,2.33,6.5,3.29,14.75,4.66c3.45,0.57,7.01,1.17,10.1,1.93l1.01,0.25L252.77,414.94z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M218.89,414.4c0,0.74,0.65,1.35,1.45,1.35h29.81c0.8,0,1.45-0.6,1.45-1.35c0-0.74-0.65-1.34-1.45-1.34 h-29.81C219.54,413.06,218.89,413.66,218.89,414.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_207_",
    gradientUnits: "userSpaceOnUse",
    x1: 3517.332,
    y1: 414.4053,
    x2: 3551.043,
    y2: 414.4053,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2903,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st212",
    d: "M218.39,414.4c0-1.02,0.88-1.84,1.95-1.84h29.81c1.08,0,1.95,0.83,1.95,1.84 c0,1.02-0.87,1.85-1.95,1.85h-29.81C219.26,416.25,218.39,415.42,218.39,414.4z M220.34,413.56c-0.52,0-0.95,0.38-0.95,0.84 c0,0.47,0.43,0.85,0.95,0.85h29.81c0.52,0,0.95-0.38,0.95-0.85c0-0.46-0.43-0.84-0.95-0.84H220.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M282.16,386.5v24.58c0,1.09-0.89,1.98-1.98,1.98h-37.18c-1.09,0-1.98-0.89-1.98-1.98V386.5 c0-1.09,0.89-1.98,1.98-1.98h37.18C281.27,384.52,282.16,385.41,282.16,386.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_208_",
    gradientUnits: "userSpaceOnUse",
    x1: 3486.7705,
    y1: 398.7881,
    x2: 3528.9199,
    y2: 398.7881,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st213",
    d: "M240.51,411.08V386.5c0-1.37,1.11-2.48,2.48-2.48h37.18c1.37,0,2.48,1.11,2.48,2.48v24.58 c0,1.37-1.11,2.48-2.48,2.48h-37.18C241.62,413.56,240.51,412.45,240.51,411.08z M242.99,385.02c-0.82,0-1.48,0.67-1.48,1.48 v24.58c0,0.82,0.67,1.48,1.48,1.48h37.18c0.82,0,1.48-0.67,1.48-1.48V386.5c0-0.82-0.67-1.48-1.48-1.48H242.99z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M243.24,414.41c0-0.74,0.6-1.35,1.34-1.35h36.12c1.02,0,1.46,0.6,1.46,1.34c0,0.74-0.44,1.35-1.46,1.35 h-36.12C243.84,415.75,243.24,415.15,243.24,414.41L243.24,414.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_209_",
    gradientUnits: "userSpaceOnUse",
    x1: 3486.7705,
    y1: 414.4053,
    x2: 3526.6953,
    y2: 414.4053,
    gradientTransform: "matrix(-1 0 0 1 3769.4316 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#964AE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    style: {
      stopColor: "#944DE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#8D55E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    style: {
      stopColor: "#8164E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6324,
    style: {
      stopColor: "#7079EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#5A94EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8371,
    style: {
      stopColor: "#3FB5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9293,
    style: {
      stopColor: "#20DCF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03FFFF"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st214",
    d: "M242.74,414.41c0-1.02,0.83-1.85,1.85-1.85h36.12c1.19,0,1.96,0.72,1.96,1.84 c0,1.12-0.77,1.85-1.96,1.85h-36.12C243.56,416.25,242.74,415.42,242.74,414.41z M244.58,413.56c-0.47,0-0.85,0.38-0.85,0.85 s0.38,0.85,0.85,0.85h36.12c0.64,0,0.96-0.28,0.96-0.85c0-0.57-0.31-0.84-0.96-0.84H244.58z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_210_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.0914,
    y1: 155.1226,
    x2: 185.0909,
    y2: 155.1226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st215",
    d: "M118.33,161.46c-4.18,0-8.11-1.51-11.07-4.26c-1.92-1.78-4.47-2.76-7.2-2.76s-5.28,0.98-7.2,2.76 c-1.11,1.03-2.99,0.96-4.02-0.15c-1.07-1.15-1-2.95,0.15-4.02c2.96-2.75,6.89-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.92,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.96-2.75,6.88-4.26,11.06-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.91,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.96-2.75,6.88-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.15,1.07,1.21,2.87,0.15,4.02c-1.03,1.11-2.91,1.17-4.02,0.15c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.19,2.76 c-2.96,2.75-6.89,4.26-11.07,4.26c-4.18,0-8.11-1.51-11.06-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 C126.44,159.95,122.51,161.46,118.33,161.46z M100.06,152.44c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.29-2.12,5.33-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.28-2.12,5.32-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c0.33,0.31,0.88,0.29,1.19-0.04 c0.31-0.34,0.3-0.87-0.04-1.19c-2.58-2.4-6.03-3.72-9.7-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.59-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.71,3.72c-0.34,0.32-0.36,0.85-0.04,1.19 c0.3,0.33,0.86,0.35,1.19,0.04C93.79,153.61,96.83,152.44,100.06,152.44z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_211_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.0803,
    y1: 173.4272,
    x2: 560.0801,
    y2: 173.4272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCA02"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F03B9A"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st216",
    d: "M493.32,179.77c-4.18,0-8.11-1.51-11.06-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 c-1.11,1.03-2.99,0.96-4.02-0.15c-1.07-1.15-1-2.95,0.15-4.02c2.96-2.75,6.89-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.92,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.95-2.75,6.88-4.26,11.07-4.26s8.11,1.51,11.07,4.26 c1.91,1.78,4.47,2.76,7.2,2.76c2.73,0,5.28-0.98,7.2-2.76c2.95-2.75,6.88-4.26,11.07-4.26c4.18,0,8.11,1.51,11.07,4.26 c1.15,1.07,1.21,2.87,0.15,4.02c-1.03,1.11-2.91,1.17-4.02,0.15c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.19,2.76 c-2.96,2.75-6.89,4.26-11.07,4.26c-4.18,0-8.11-1.51-11.06-4.26c-1.92-1.78-4.47-2.76-7.2-2.76c-2.73,0-5.28,0.98-7.2,2.76 C501.43,178.26,497.5,179.77,493.32,179.77z M475.05,170.75c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.29-2.12,5.33-3.29,8.56-3.29c3.23,0,6.27,1.17,8.56,3.29c2.58,2.4,6.03,3.72,9.7,3.72 c3.67,0,7.12-1.32,9.71-3.72c2.28-2.12,5.32-3.29,8.55-3.29c3.23,0,6.27,1.17,8.56,3.29c0.33,0.31,0.88,0.29,1.19-0.04 c0.32-0.34,0.3-0.87-0.04-1.19c-2.58-2.4-6.03-3.72-9.7-3.72s-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.58-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.7,3.72c-2.29,2.12-5.33,3.29-8.56,3.29 c-3.23,0-6.27-1.17-8.56-3.29c-2.59-2.4-6.03-3.72-9.71-3.72c-3.67,0-7.12,1.32-9.71,3.72c-0.34,0.32-0.36,0.85-0.04,1.19 c0.3,0.33,0.86,0.35,1.19,0.04C468.78,171.92,471.82,170.75,475.05,170.75z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_212_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.4307,
    y1: 129.6172,
    x2: 245.4307,
    y2: 129.6172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 205.43,
    y: 128.62,
    className: "st217",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_213_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.4893,
    y1: 215.5361,
    x2: 548.8526,
    y2: 215.5361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 526.49,
    y: 214.54,
    className: "st218",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_214_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.2549,
    y1: 180.4443,
    x2: 156.6182,
    y2: 180.4443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 134.25,
    y: 179.44,
    className: "st219",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_215_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.086,
    y1: 158.1006,
    x2: 499.2256,
    y2: 158.1006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 489.09,
    y: 157.1,
    className: "st220",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_216_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.0479,
    y1: 299.3398,
    x2: 574.9092,
    y2: 299.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st221",
    d: "M571.48,302.77c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 S573.37,302.77,571.48,302.77z M571.48,297.91c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C572.91,298.55,572.27,297.91,571.48,297.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_217_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.9053,
    y1: 154.73,
    x2: 455.7666,
    y2: 154.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st222",
    d: "M452.34,158.16c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C455.77,156.62,454.23,158.16,452.34,158.16z M452.34,153.3c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C453.77,153.94,453.12,153.3,452.34,153.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_218_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.3408,
    y1: 135.0468,
    x2: 141.2022,
    y2: 135.0468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st223",
    d: "M137.77,138.48c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C141.2,136.94,139.66,138.48,137.77,138.48z M137.77,133.62c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C139.2,134.26,138.56,133.62,137.77,133.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_219_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.1533,
    y1: 191.6172,
    x2: 116.0137,
    y2: 191.6172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st224",
    d: "M112.58,195.05c-1.89,0-3.43-1.54-3.43-3.43c0-1.89,1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 C116.01,193.51,114.47,195.05,112.58,195.05z M112.58,190.19c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C114.01,190.83,113.37,190.19,112.58,190.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_220_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.6826,
    y1: 132.5381,
    x2: 178.1123,
    y2: 132.5381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st225",
    points: "174.1,135.25 172.68,133.84 176.7,129.82 178.11,131.24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_221_",
    gradientUnits: "userSpaceOnUse",
    x1: 1444.2563,
    y1: 1304.748,
    x2: 1449.686,
    y2: 1304.748,
    gradientTransform: "matrix(0 1 -1 0 1480.1455 -1314.4331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st226",
    points: "176.7,135.25 172.68,131.24 174.1,129.82 178.11,133.84  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_222_",
    gradientUnits: "userSpaceOnUse",
    x1: 555.917,
    y1: 269.5146,
    x2: 578.2803,
    y2: 269.5146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 555.92,
    y: 268.51,
    className: "st227",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_223_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.6797,
    y1: 202.4218,
    x2: 533.1104,
    y2: 202.4218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st228",
    points: "529.09,205.14 527.68,203.72 531.7,199.71 533.11,201.12  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_224_",
    gradientUnits: "userSpaceOnUse",
    x1: 1514.1401,
    y1: 949.7504,
    x2: 1519.5698,
    y2: 949.7504,
    gradientTransform: "matrix(0 1 -1 0 1480.1455 -1314.4331)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st229",
    points: "531.7,205.14 527.68,201.12 529.09,199.71 533.11,203.72  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_225_",
    gradientUnits: "userSpaceOnUse",
    x1: 2144.4561,
    y1: -99.2139,
    x2: 2184.4561,
    y2: -99.2139,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 532.25,
    y: 278.38,
    className: "st230",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_226_",
    gradientUnits: "userSpaceOnUse",
    x1: 2224.3682,
    y1: -18.5371,
    x2: 2264.3682,
    y2: -18.5371,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 452.34,
    y: 197.71,
    className: "st231",
    width: 40,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_227_",
    gradientUnits: "userSpaceOnUse",
    x1: 2302.7354,
    y1: 46.6318,
    x2: 2331.7871,
    y2: 46.6318,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 384.92,
    y: 132.54,
    className: "st232",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_228_",
    gradientUnits: "userSpaceOnUse",
    x1: 2334.8135,
    y1: 46.6318,
    x2: 2342.7354,
    y2: 46.6318,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 373.97,
    y: 132.54,
    className: "st233",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_229_",
    gradientUnits: "userSpaceOnUse",
    x1: 2481.5684,
    y1: 73.8564,
    x2: 2503.9316,
    y2: 73.8564,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 212.77,
    y: 105.31,
    className: "st234",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_230_",
    gradientUnits: "userSpaceOnUse",
    x1: 2284.5469,
    y1: 68.3056,
    x2: 2294.6865,
    y2: 68.3056,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 422.02,
    y: 110.86,
    className: "st235",
    width: 10.14,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_231_",
    gradientUnits: "userSpaceOnUse",
    x1: 2161.3545,
    y1: -11.4478,
    x2: 2168.2158,
    y2: -11.4478,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st236",
    d: "M551.92,195.05c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 S553.81,195.05,551.92,195.05z M551.92,190.19c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C553.35,190.83,552.71,190.19,551.92,190.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_232_",
    gradientUnits: "userSpaceOnUse",
    x1: 2499.1592,
    y1: 32.8188,
    x2: 2506.0195,
    y2: 32.8188,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st237",
    d: "M214.11,150.78c-1.89,0-3.43-1.54-3.43-3.43s1.54-3.43,3.43-3.43s3.43,1.54,3.43,3.43 S216.01,150.78,214.11,150.78z M214.11,145.92c-0.79,0-1.43,0.64-1.43,1.43c0,0.79,0.64,1.43,1.43,1.43 c0.79,0,1.43-0.64,1.43-1.43C215.54,146.56,214.9,145.92,214.11,145.92z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_233_",
    gradientUnits: "userSpaceOnUse",
    x1: 2590.0654,
    y1: -32.1021,
    x2: 2595.4951,
    y2: -32.1021,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st238",
    points: "122.62,214.99 121.21,213.57 125.22,209.56 126.64,210.97  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_234_",
    gradientUnits: "userSpaceOnUse",
    x1: 2590.0654,
    y1: -32.1021,
    x2: 2595.4951,
    y2: -32.1021,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st239",
    points: "122.62,214.99 121.21,213.57 125.22,209.56 126.64,210.97  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_235_",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.6154,
    y1: -1112.6343,
    x2: 1285.046,
    y2: -1112.6343,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st240",
    points: "125.22,214.99 121.21,210.97 122.62,209.56 126.64,213.57  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_236_",
    gradientUnits: "userSpaceOnUse",
    x1: 2533.582,
    y1: 74.3716,
    x2: 2539.0117,
    y2: 74.3716,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st241",
    points: "179.11,108.51 177.69,107.1 181.71,103.08 183.12,104.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_237_",
    gradientUnits: "userSpaceOnUse",
    x1: 2533.582,
    y1: 74.3716,
    x2: 2539.0117,
    y2: 74.3716,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st242",
    points: "179.11,108.51 177.69,107.1 181.71,103.08 183.12,104.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_238_",
    gradientUnits: "userSpaceOnUse",
    x1: 1386.0889,
    y1: -1056.1509,
    x2: 1391.5197,
    y2: -1056.1509,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st243",
    points: "181.71,108.51 177.69,104.5 179.11,103.08 183.12,107.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_239_",
    gradientUnits: "userSpaceOnUse",
    x1: 2410.0635,
    y1: 50.5527,
    x2: 2439.1162,
    y2: 50.5527,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 277.59,
    y: 128.62,
    className: "st244",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_240_",
    gradientUnits: "userSpaceOnUse",
    x1: 2442.1426,
    y1: 50.5527,
    x2: 2450.0635,
    y2: 50.5527,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 266.64,
    y: 128.62,
    className: "st245",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_241_",
    gradientUnits: "userSpaceOnUse",
    x1: 2572.042,
    y1: -50.3487,
    x2: 2601.0947,
    y2: -50.3487,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 115.61,
    y: 229.52,
    className: "st246",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_242_",
    gradientUnits: "userSpaceOnUse",
    x1: 2604.1211,
    y1: -50.3487,
    x2: 2612.042,
    y2: -50.3487,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 104.66,
    y: 229.52,
    className: "st247",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_243_",
    gradientUnits: "userSpaceOnUse",
    x1: 2504.0801,
    y1: 13.2314,
    x2: 2526.4434,
    y2: 13.2314,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 190.26,
    y: 165.94,
    className: "st248",
    width: 22.36,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_244_",
    gradientUnits: "userSpaceOnUse",
    x1: 2556.7412,
    y1: 60.1797,
    x2: 2585.793,
    y2: 60.1797,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 118.99,
    className: "st249",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_245_",
    gradientUnits: "userSpaceOnUse",
    x1: 2588.8193,
    y1: 60.1797,
    x2: 2596.7412,
    y2: 60.1797,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 119.96,
    y: 118.99,
    className: "st250",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_246_",
    gradientUnits: "userSpaceOnUse",
    x1: 2449.0752,
    y1: 70.0396,
    x2: 2454.5049,
    y2: 70.0396,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st251",
    points: "263.61,112.85 262.2,111.43 266.21,107.42 267.63,108.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_247_",
    gradientUnits: "userSpaceOnUse",
    x1: 2449.0752,
    y1: 70.0396,
    x2: 2454.5049,
    y2: 70.0396,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st252",
    points: "263.61,112.85 262.2,111.43 266.21,107.42 267.63,108.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_248_",
    gradientUnits: "userSpaceOnUse",
    x1: 1381.757,
    y1: -971.644,
    x2: 1387.1876,
    y2: -971.644,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st253",
    points: "266.21,112.85 262.2,108.83 263.61,107.42 267.63,111.43  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_249_",
    gradientUnits: "userSpaceOnUse",
    x1: 2373.834,
    y1: 47.8378,
    x2: 2379.2637,
    y2: 47.8378,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st254",
    points: "338.85,135.05 337.44,133.63 341.46,129.62 342.87,131.03  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_250_",
    gradientUnits: "userSpaceOnUse",
    x1: 2373.834,
    y1: 47.8378,
    x2: 2379.2637,
    y2: 47.8378,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st255",
    points: "338.85,135.05 337.44,133.63 341.46,129.62 342.87,131.03  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_251_",
    gradientUnits: "userSpaceOnUse",
    x1: 1359.5557,
    y1: -896.4028,
    x2: 1364.9854,
    y2: -896.4028,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st256",
    points: "341.46,135.05 337.44,131.03 338.85,129.62 342.87,133.63  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_252_",
    gradientUnits: "userSpaceOnUse",
    x1: 2378.7412,
    y1: 61.1797,
    x2: 2407.793,
    y2: 61.1797,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 308.91,
    y: 117.99,
    className: "st257",
    width: 29.05,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_253_",
    gradientUnits: "userSpaceOnUse",
    x1: 2410.8193,
    y1: 61.1797,
    x2: 2418.7412,
    y2: 61.1797,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 297.96,
    y: 117.99,
    className: "st258",
    width: 7.92,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_254_",
    gradientUnits: "userSpaceOnUse",
    x1: 2277.1221,
    y1: 51.5581,
    x2: 2282.5518,
    y2: 51.5581,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st259",
    points: "435.57,131.33 434.15,129.91 438.17,125.9 439.58,127.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_255_",
    gradientUnits: "userSpaceOnUse",
    x1: 2277.1221,
    y1: 51.5581,
    x2: 2282.5518,
    y2: 51.5581,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st260",
    points: "435.57,131.33 434.15,129.91 438.17,125.9 439.58,127.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_256_",
    gradientUnits: "userSpaceOnUse",
    x1: 1363.2755,
    y1: -799.6909,
    x2: 1368.7061,
    y2: -799.6909,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st261",
    points: "438.17,131.33 434.15,127.31 435.57,125.9 439.58,129.91  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_257_",
    gradientUnits: "userSpaceOnUse",
    x1: 2141.7412,
    y1: -68.9736,
    x2: 2147.1709,
    y2: -68.9736,
    gradientTransform: "matrix(-1 0 0 -1 2716.7041 180.1699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st262",
    points: "570.95,251.86 569.53,250.44 573.55,246.43 574.96,247.84  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_258_",
    gradientUnits: "userSpaceOnUse",
    x1: 1242.7441,
    y1: -664.3101,
    x2: 1248.174,
    y2: -664.3101,
    gradientTransform: "matrix(0 -1 1 0 1236.5581 1494.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0399C"
    }
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st263",
    points: "573.55,251.86 569.53,247.84 570.95,246.43 574.96,250.44  "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog5);
export default __webpack_public_path__ + "static/media/blog5.2599a6b148b590c6ae22f160bfb1278e.svg";
export { ForwardRef as ReactComponent };